<template>
  <div class="mob-index">
    <!--    聊天 start-->
    <div class="chat-container" v-if="chatShow === 'chat' || chatShow === 'viewHis'">
      <div class="chat-header clearfix">
        <div class="h-service-wrap clearfix">
          <div class="h-service-avatar fl" v-if="chatShow === 'chat'">
            <img class="avatar" :src="serviceAvatar" alt />
          </div>
          <div class="h-service-avatar fl" v-if="chatShow === 'viewHis'" style="display: flex;align-items: center;width: 20px;">
            <van-icon name="arrow-left" style="cursor: pointer;font-size: 18px;" @click="returnBack" />
          </div>
          <div class="h-service-nickname fl">
            <div class="serviceName">{{serviceName}}</div>
            <div class="signInfo" v-if="this.$store.state.agent_sign">{{this.$store.state.agent_sign}}</div>
            <div class="signInfo" v-else-if="agent_sign">{{agent_sign}}</div>
          </div>
        </div>
        <div class="h-page-handler-wrap clearfix">
          <div class="h-page-handler-item" style="margin-right: 10px;font-size: 12px;line-height: 23px;border:1px solid #fff;border-radius:13px;padding:0 6px;" v-if="!chatend && (loginInfo && loginInfo.agent_type ==='robot')">
            <span class="toHuman" @click="robotTurnManual">转人工客服</span>
          </div>
          <div class="h-page-handler-item">
            <svg-icon icon-class="close" style="width: 13px;" @click.native="closeBtn"></svg-icon>
            <!-- <span class="back" @click="closeBtn">返回店铺</span> -->
          </div>
        </div>
      </div>
      <div class="chat-main" ref="detailCont" id="chatMain" @scroll="contentScroll">
        <div class="load-history" v-if="messageHistory && !isLoading">
          <span @click="loadHistory">查看更多历史消息</span>
          <img src="@/assets/images/mobile/toUp.png" alt="">
        </div>
        <div style="text-align: center;" v-if="isLoading">
          <van-loading size="24px">加载中...</van-loading>
        </div>
        <div class="message-container" v-for="(msg, i) in messages" :key="i">
          <!--          消息时间 start-->
          <div class="msg-times" v-if="$utils.msgTimeRender(msg.sendtime)">
            <span>{{$utils.msgTimeRender(msg.sendtime)}}</span>
          </div>
          <!--          消息时间 end-->

          <div class="event-msg msg-item" v-if="msg.role === 'event'">
            <span v-html="msg.text"></span>
          </div>

          <!--          客服消息 start-->
          <div v-if="msg.role === 'agent'" class="agent-msg msg-item clearfix" :data-callingId="msg.callingId || msg.calling_id"
            :data-isRead="msg.is_read">
            <!-- <div class="chat-avatar">
              <img class="avatar" :src="msg.agent_avatar" alt />
            </div> -->
            <div class="chat-content">
              <div class="msg-time">{{msg.agent_nickname}}</div>
              <div class="msg-content customerNew" :class="msg.msg_type === 'goods' ? 'goodsMsg' : ''">
                <div v-if="msg.isCsReply == 1" style="color: #999;padding-bottom: 6px;font-size: 12px;">{{msg.visitorName}}</div>
                <div v-if="msg.isCsReply == 1" style="color: #999;padding: 0 8px 5px;box-sizing: border-box;border-bottom: 1px solid #ddd;margin-bottom: 5px;"
                  v-html="msg.csReplyText"></div>
                <div class="textMsg" v-if="msg.msg_type === 'text'">
                  <span v-if="msg.isCsReply == 1" style="color: #333;padding-left: 5px;box-sizing: border-box;">回复：</span>
                  <span v-html="$utils.renderUrl(formatTrendEmoji(msg.text))"></span>
                  <div class="reply-operate" v-if="msg.libType!=0 && msg.handler" v-html="msg.handler"></div>
                </div>
                <div class="imgMsg" v-if="msg.msg_type === 'image'">
                  <img :src="msg.text" alt preview="0" />
                </div>
                <div class="voiceMsg" @click="voicePlay($event)" v-if="msg.msg_type === 'voice'"  :style="'padding-right:' + msg.talk_time * 2 + 'px'">
                  <audio class="audioId" preload="auto" hidden="true" index="1" ref="audio">
                    <source :src="msg.text" type="audio/mpeg" />
                  </audio>
                  <div class="wifi-symbol voice-agent">
                    <div class="wifi-circle first"></div>
                    <div class="wifi-circle second" ref="second"></div>
                    <div class="wifi-circle third" ref="third"></div>
                  </div>
                  <span>{{msg.talk_time}}''</span>
                </div>
                <div class="videoMsg" v-if="msg.msg_type === 'video'">
                  <video class="videoId" preload :poster="msg.reduced_graph" @click="videoStop($event)" @play="watchVideoPlay"
                    @pause="watchVideoPause" @ended="watchVideoEnded">
                    <source :src="msg.text" type="video/mp4" />
                  </video>
                  <div class="poster"><img :src="msg.reduced_graph" /></div>
                  <div class="video-mask">
                    <svg-icon class="playBtn" icon-class="videoplay" @click.native="videoPlay($event)"></svg-icon>
                  </div>
                </div>
                <div class="fileMsg" v-if="msg.msg_type === 'file'">
                  <span class="file-icon"></span>
                  <!-- <svg-icon icon-class="file"></svg-icon> -->
                  <span>{{msg.text.split(',')[0]}}</span>
                  <a class="view-file" target="_blank" :href="msg.text.split(',')[1]" download>查看文件</a>
                </div>
                <div class="goodMsg" v-if="msg.msg_type === 'goods'">
                  <div class="send-goods-box">
                    <a @click="linkToGoods(JSON.parse(msg.text))" class="clearfix send-goods-info-box">
                      <div class="send-goods-image">
                        <img :src="JSON.parse(msg.text).img" alt="商品图" />
                      </div>
                      <div class="send-goods-info">
                        <div class="send-goods-price">
                          ¥<span>{{JSON.parse(msg.text).price}}</span>
                        </div>
                        <div class="send-goods-title">
                          {{JSON.parse(msg.text).title.length > 30 ?
                          JSON.parse(msg.text).title.slice(0, 29)+'...' : JSON.parse(msg.text).title}}
                        </div>

                      </div>
                    </a>
                  </div>
                </div>
                <!-- 优惠券 -->
                <div class="couponMsg" v-if="msg.msg_type === 'coupon'">
                  <a :href="JSON.parse(msg.text).link" target="_blank" class="coupon-container clearfix">
                    <div class="coupon-image fl">
                      <img src="@/assets/images/coupon.png" alt />
                    </div>
                    <div class="coupon-content fl">
                      <div class="coupon-title">{{JSON.parse(msg.text).title}}</div>
                      <div class="coupon-desc">
                        {{JSON.parse(msg.text).start_time | formateDateTime}}<span></span>
                        {{JSON.parse(msg.text).end_time | formateDateTime}}
                      </div>
                      <div class="coupon-price">{{JSON.parse(msg.text).price}}</div>
                    </div>
                  </a>
                </div>
                <div class="expressMsg" v-if="msg.msg_type === 'express'">
                  <div class="express-container">
                    <div class="order-no-type">
                      <div class="order-type" :class="renderOrderStatusClass(JSON.parse(msg.text).status)">
                        <span>{{renderOrderStatus(JSON.parse(msg.text).status)}}</span>
                      </div>
                      <div class="order-no">
                        <span>订单编号:</span>
                        <span class="no">{{JSON.parse(msg.text).order_no}}</span>
                      </div>
                    </div>
                    <a :href="JSON.parse(msg.text).link" target="_blank" class="order-container clearfix">
                      <div class="order-goods-image fl">
                        <img :src="JSON.parse(msg.text).img" alt="商品" />
                      </div>
                      <div class="order-goods-info fl">
                        <div class="order-goods-title">{{JSON.parse(msg.text).title}}</div>
                        <div class="order-goods-count" v-if="JSON.parse(msg.text).allGoodsNum && JSON.parse(msg.text).totalPrice">
                          共{{JSON.parse(msg.text).allGoodsNum}}件商品,
                          合计￥{{JSON.parse(msg.text).totalPrice}}
                        </div>
                        <div v-else class="order-goods-price">¥ {{JSON.parse(msg.text).price}}</div>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="orderInfoMsg" v-if="msg.msg_type === 'orderInfo'">
                  <div class="order-msg-title">当前交易&nbsp;&nbsp;{{JSON.parse(msg.text).data.number}}</div>
                  <div class="order-msg-goods-container clearfix" @click="linkToOrder(JSON.parse(msg.text).data.number)">
                    <div class="order-goods-img">
                      <img :src="JSON.parse(msg.text).data.goods[0].imgUrls" alt="商品图" />
                    </div>
                    <div class="order-goods-detail">
                      <div class="order-goods-name">{{JSON.parse(msg.text).data.goods[0].title}}</div>
                      <div class="order-goods-count">
                        共{{JSON.parse(msg.text).data.goods.length}}件商品,
                        合计￥{{JSON.parse(msg.text).data.total_price}}
                      </div>
                    </div>
                  </div>
                  <div class="order-msg-addr">
                    <div class="addr-item clearfix">
                      <div class="label-name">姓名：</div>
                      <div class="label-content">{{JSON.parse(msg.text).data.consignee_name}}</div>
                    </div>
                    <div class="addr-item clearfix">
                      <div class="label-name">电话：</div>
                      <div class="label-content">{{JSON.parse(msg.text).data.consignee_phone}}</div>
                    </div>
                    <div class="addr-item clearfix">
                      <div class="label-name">地址：</div>
                      <div class="label-content">{{JSON.parse(msg.text).data.consignee_address}}</div>
                    </div>
                  </div>
                  <div class="order-msg-operate clearfix">
                    <div class="returnGoods" v-if="JSON.parse(msg.text).flag === '1' && JSON.parse(msg.text).data.refunding_url != ''">
                      <a :href="JSON.parse(msg.text).data.refunding_url" target="_blank">退货</a>
                    </div>
                    <div v-if="JSON.parse(msg.text).flag === '1' && JSON.parse(msg.text).data.exchange_url != ''">
                      <a :href="JSON.parse(msg.text).data.exchange_url" target="_blank">换货</a>
                    </div>
                    <div v-if=" msg.agent_type === 'robot'">
                      <span class="toHuman js_manual">人工客服</span>
                    </div>
                  </div>
                </div>
                <div class="placeOrderMsg" v-if="msg.msg_type === 'place_order'">
                  <div v-if="JSON.parse(msg.text).status == 0" class="orderTitle">亲，您有一笔订单未付款~</div>
                  <div v-else class="orderTitle">亲，请您核对订单信息</div>
                  <a :href="JSON.parse(msg.text).orderUrl" target="_blank" class="orderGood-container">
                    <div class="goods-image">
                      <img :src="JSON.parse(msg.text).image" alt />
                    </div>
                    <div class="goods-detail">
                      <div class="goods-order-title">{{JSON.parse(msg.text).title}}</div>
                      <div class="goods-order-detail goods-order-bpttom">共计{{JSON.parse(msg.text).goodsNum}}件商品，合计￥{{JSON.parse(msg.text).payment}}</div>
                    </div>
                  </a>
                  <div v-if="JSON.parse(msg.text).status == 1">
                    <div class="addressInfo">
                      <span class="label">姓名：</span>
                      <span class="detail">{{JSON.parse(msg.text).name}}</span>
                    </div>
                    <div class="addressInfo">
                      <span class="label">电话：</span>
                      <span class="detail">{{JSON.parse(msg.text).mobile}}</span>
                    </div>
                    <div class="addressInfo">
                      <span class="label">地址：</span>
                      <span class="detail">{{JSON.parse(msg.text).receiverAddress}}</span>
                    </div>
                    <div class="operation-btn" style="margin-top: 5px;" v-if="initialData.is_open_modify_address == 1">
                      <span v-if="JSON.parse(msg.text).addressState == 0" class="editBtn" @click="editAddr(JSON.parse(msg.text).orderId, JSON.parse(msg.text).callingId)">修改</span>
                      <span v-if="JSON.parse(msg.text).addressState == 0" class="confirmBtn" @click="confirmAddr(JSON.parse(msg.text).orderId, JSON.parse(msg.text).callingId,1, JSON.parse(msg.text).receiverAddress, JSON.parse(msg.text).name, JSON.parse(msg.text).mobile)">确认</span>
                      <span v-if="JSON.parse(msg.text).addressState == 1" class="confirmBtned had">已确认</span>
                    </div>
                    <div class="operation-btn" style="margin-top: 5px;" v-if="initialData.is_open_modify_address == 0">
                      <a style="display: inline-block;" :href="JSON.parse(msg.text).orderUrl" target="_blank" class="review-order-btn">查看订单</a>
                    </div>
                  </div>
                  <div class="operation-btn" style="margin-top: 5px;" v-if="JSON.parse(msg.text).status == 0">
                    <a style="display: inline-block;" :href="JSON.parse(msg.text).orderUrl" target="_blank" class="review-order-btn">去付款</a>
                  </div>
                </div>
                <div class="arrivalMsg" v-if="msg.msg_type === 'arrival_notice'">
                  <div class="orderTitle">验收提醒</div>
                  <a :href="JSON.parse(msg.text).orderUrl" target="_blank" class="orderGood-container">
                    <div class="goods-image">
                      <img :src="JSON.parse(msg.text).image" alt />
                    </div>
                    <div class="goods-detail">
                      <div class="goods-order-title">{{JSON.parse(msg.text).title}}</div>
                      <div class="goods-order-detail">共计{{JSON.parse(msg.text).goodsNum}}件商品，合计￥{{JSON.parse(msg.text).payment}}</div>
                    </div>
                  </a>
                  <div class="deliveryTips">{{JSON.parse(msg.text).acceptanceMsg}}</div>
                  <div class="operation-btn">
                    <a :href="JSON.parse(msg.text).orderUrl" target="_blank" class="review-order-btn">查看订单</a>
                  </div>
                </div>
                <div class="deliveryMsg" v-if="msg.msg_type === 'delivery_notice'">
                  <div class="orderTitle">订单已发货</div>
                  <a :href="JSON.parse(msg.text).orderUrl" target="_blank" class="orderGood-container">
                    <div class="goods-image">
                      <img :src="JSON.parse(msg.text).image" alt />
                    </div>
                    <div class="goods-detail">
                      <div class="goods-order-title">{{JSON.parse(msg.text).title}}</div>
                      <div class="goods-order-detail">共计{{JSON.parse(msg.text).goodsNum}}件商品，合计￥{{JSON.parse(msg.text).payment}}</div>
                    </div>
                  </a>
                  <div class="deliveryInfo" v-if="showMore" v-for="(item, i) in JSON.parse(msg.text).logistics" :key="i">
                    <div class="deliveryInfo-item">
                      <div class="deliveryInfo-label">物流公司：</div>
                      <div class="deliveryInfo-detail">{{item.express}}</div>
                    </div>
                    <div class="deliveryInfo-item">
                      <div class="deliveryInfo-label">快递单号：</div>
                      <div class="deliveryInfo-detail">{{item.expressNo}}</div>
                    </div>
                    <div class="deliveryInfo-item" v-if="item.receiverAddress">
                      <div class="deliveryInfo-label">收货地址：</div>
                      <div class="deliveryInfo-detail">{{item.receiverAddress}}</div>
                    </div>
                  </div>
                  <div class="deliveryInfo" v-if="JSON.parse(msg.text).logistics[0] && !showMore">
                    <div class="deliveryInfo-item">
                      <div class="deliveryInfo-label">物流公司：</div>
                      <div class="deliveryInfo-detail">{{JSON.parse(msg.text).logistics[0].express}}</div>
                    </div>
                    <div class="deliveryInfo-item">
                      <div class="deliveryInfo-label">快递单号：</div>
                      <div class="deliveryInfo-detail">{{JSON.parse(msg.text).logistics[0].expressNo}}</div>
                    </div>
                  </div>
                  <div style="text-align: center;font-size: 18px;padding-top: 0;
                color: #333;color: #ccc" v-if="JSON.parse(msg.text).logistics.length > 1 && !showMore">
                    <van-icon name="arrow-down" style="cursor: pointer;" @click="showMore = true" />
                  </div>
                  <div class="operation-btn">
                    <a :href="JSON.parse(msg.text).orderUrl" target="_blank" class="review-order-btn">查看订单</a>
                  </div>
                </div>

                <div class="refundMsg" v-if="msg.msg_type === 'refund_notice'">
                  <div class="orderTitle">退/换货已通过审核</div>
                  <div class="order-msg-no">订单编号：{{JSON.parse(msg.text).orderNo}}</div>
                  <a :href="JSON.parse(msg.text).orderUrl" target="_blank" class="orderGood-container">
                    <div class="goods-image">
                      <img :src="JSON.parse(msg.text).image" alt />
                    </div>
                    <div class="goods-detail">
                      <div class="goods-order-title">{{JSON.parse(msg.text).title}}</div>
                      <div class="goods-order-detail">共计{{JSON.parse(msg.text).allGoodsNum}}件商品，合计￥{{JSON.parse(msg.text).allGoodsPayment}}</div>
                    </div>
                  </a>
                  <div class="refundInfo">
                    <p>共计 {{JSON.parse(msg.text).goodsNum}} 件商品</p>
                    <p>实际退款：<span class="price">￥{{JSON.parse(msg.text).payment}}</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--          客服消息 end-->

          <!--          访客消息 start-->
          <div class="client-msg msg-item clearfix" v-if="msg.role === 'client'">
            <!-- <div class="chat-avatar">
              <img v-if="loginInfo.client_avatar" class="avatar" :src="loginInfo.client_avatar" alt="">

              <p v-else>我</p>
            </div> -->
            <div class="chat-content" :class="whiteIconClass(msg.msg_type)">
                           <!-- <div class="msg-time">{{msg.sendtime}}</div> -->
              <div class="msg-time">{{loginInfo.client_nickname}}</div>
              <div v-if="initialData.is_show_read" class="isreadText" :class="msg.is_read&&msg.is_read==1?'hasRead':'unRead'">{{msg.is_read&&msg.is_read==1?'已读':'未读'}}</div>
              <div class="msg-content textMsg visitorNews" v-if="msg.msg_type === 'text'" v-html="$utils.renderUrl(formatTrendEmoji(msg.text))"></div>
              <div class="msg-content imgMsg visitorNews" v-if="msg.msg_type === 'image'">
                <img :src="msg.text" alt preview="0" />
              </div>
              <div class="msg-content voiceMsg visitorNews" @click="voicePlay($event)" v-if="msg.msg_type === 'voice'" :style="'padding-left:' + msg.talk_time * 2 + 'px'">
                <audio class="audioId" preload="auto" hidden="true" index="2" ref="audio">
                  <source :src="msg.text" type="audio/mpeg" />
                </audio>
                <div class="wifi-symbol voice-client">
                  <div class="wifi-circle first"></div>
                  <div class="wifi-circle second" ref="second"></div>
                  <div class="wifi-circle third" ref="third"></div>
                </div>
                <span>{{msg.talk_time}}''</span>
              </div>
              <div class="msg-content videoMsg visitorNews" v-if="msg.msg_type === 'video'">
                <video class="videoId" preload :poster="msg.reduced_graph" @click="videoStop($event)" @play="watchVideoPlay"
                  @pause="watchVideoPause" @ended="watchVideoEnded">
                  <source :src="msg.text" type="video/mp4" />
                </video>
                <div class="poster"><img :src="msg.reduced_graph" /></div>
                <div class="video-mask">
                  <svg-icon class="playBtn" icon-class="videoplay" @click.native="videoPlay($event)"></svg-icon>
                </div>
              </div>
              <div class="msg-content fileMsg visitorNews" v-if="msg.msg_type === 'file'">
                <svg-icon icon-class="file"></svg-icon>
                <span>{{msg.text.split(',')[0]}}</span>
                <a class="view-file" target="_blank" :href="msg.text.split(',')[1]" download>查看文件</a>
              </div>
              <div class="msg-content goodMsg visitorNews" v-if="msg.msg_type === 'goods'">
                <div class="send-goods-box">
                  <a @click="linkToGoods(JSON.parse(msg.text))" class="clearfix send-goods-info-box">
                    <div class="send-goods-image">
                      <img :src="JSON.parse(msg.text).img" alt="商品图" />
                    </div>
                    <div class="send-goods-info">
                      <div class="send-goods-price">
                        ¥
                        <span>{{JSON.parse(msg.text).price}}</span>
                      </div>
                      <div class="send-goods-title">
                        {{JSON.parse(msg.text).title.length > 30 ?
                        JSON.parse(msg.text).title.slice(0, 29)+'...' : JSON.parse(msg.text).title}}
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!--          访客消息 end-->

          <!--          访客发送商品消息 start-->
          <div v-if="msg.role === 'sendGoods' && msg.isShow === 'show' && showSendGoods" class="msg-item send-goods-container">
            <div class="send-goods-box">
              <a class="clearfix send-goods-info-box">
                <div class="fl send-goods-image">
                  <img :src="JSON.parse(msg.text).img" alt="商品图" />
                </div>
                <div class="fl send-goods-info">
                  <div class="send-goods-title">
                    {{JSON.parse(msg.text).title.length > 30 ?
                    JSON.parse(msg.text).title.slice(0, 29)+'...' : JSON.parse(msg.text).title}}
                  </div>
                  <div class="send-goods-price">
                    ¥
                    <span>{{JSON.parse(msg.text).price}}</span>
                  </div>
                </div>
              </a>
              <div class="send-goods-btn-wrap">
                <span class="send-goods-btn" @click="sendGoodsLink(msg.text)">发送给客服</span>
              </div>
            </div>
          </div>
          <!--          访客发送商品消息 end-->
        </div>

      </div>
      <div class="chat-bottom" v-if="chatShow === 'chat'">
        <div class="quick-guide-box" v-if="initialData.calling_config.is_open_quick_guide==1&&quickGuideList.length">
          <p>我想</p>
          <ul class="quick-guide-list">
            <li v-for="item in quickGuideList" :class="{hide:initialData.is_evaluat==0&&item.type==1&&item.guideTag=='评价'}"
              @click="clickQuickGuide(item)">{{item.guideTag}}</li>
          </ul>
        </div>
        <div class="chat-input-contianer chat-operate" v-if="chatWithService">
          <div class="operate-icon" v-if="initialData.is_voice">
            <span style="margin-left: 0;" v-if="isText" class="operation-voice" @click="toRecord"></span>
            <!-- <svg-icon style="margin-left: 0;" v-if="isText" icon-class="voice" @click.native="toRecord"></svg-icon> -->
            <svg-icon style="margin-left: 0;" v-else icon-class="keyboard" @click.native="toText"></svg-icon>
          </div>
          <div class="input-wrap" :class="isText ? 'wrap-padding' : ''" :style="initialData.is_voice ? '' :'margin-left:  0;'">
            <input v-if="isText" v-model="msgContent" @focus="inputFocus" @keypress="enterSendMsg($event)" ref="textInput"
              type="text" placeholder="请描述您的问题..." />
            <span v-else class="voiceRecordBtn" @touchstart.prevent="gtouchstart()" @touchmove="gtouchmove()" @touchend="gtouchend()"
              @touchcancel="gtouchcancel()">按住录音</span>
          </div>
          <div class="operate-icon left">
            <span class="operation-emoji" @click="showEmojiFn($event)"></span>
            <!-- <svg-icon icon-class="emoji" @click.native="showEmojiFn($event)"></svg-icon> -->
          </div>
          <div class="operate-icon">
            <span v-if="showSendBtn" class="sendBtn" @click="sendMsg">发送</span>
            <span v-else class="operation-plus" @click="showMoreFunction"></span>
            <!-- <svg-icon v-else icon-class="plus" @click.native="showMoreFunction"></svg-icon> -->
          </div>
        </div>
        <div class="ai-tips">内容由 AI 生成</div>
        <div class="chat-end-container chat-operate" v-if="chatend">
          <ul class="chat-end-operate clearfix" :class="initialData.is_evaluat ? '' : 'no-evaluate' ">
            <li v-if="initialData.is_evaluat">
              <div>
                <svg-icon @click.native="toEvaluate" icon-class="heart" style="margin-top: -3px;"></svg-icon>
              </div>
              <div class="chat-end-operate-title" @click="toEvaluate">满意度</div>
            </li>
            <li>
              <div>
                <svg-icon @click.native="chatReload" icon-class="chat" style="margin-top: -3px;"></svg-icon>
              </div>
              <div class="chat-end-operate-title" @click="chatReload">继续会话</div>
            </li>
            <li>
              <div>
                <svg-icon @click.native="toLeaveMsg" icon-class="leavemsg" style="margin-top: -3px;"></svg-icon>
              </div>
              <div @click="toLeaveMsg" class="chat-end-operate-title">留言</div>
            </li>
          </ul>
        </div>
        <div class="chat-end-container chat-operate black-container" v-if="isBlack">抱歉，客服系统暂时无法使用</div>
        <div class="more-operation">
          <vue-emoji class="emoji_pannel" @selectedEmoji="selectEmoji" v-show="showEmoji"></vue-emoji>
          <div class="css_moreFn" v-if="showMoreFn">
            <div class="fnItem" v-if="initialData.is_upload">
              <div class="itemPosition" @click="imageClick">
                <svg-icon icon-class="image"></svg-icon>
                <p class="itemName">图片</p>
                <input @change="uploadImageOrVideo" v-show="false" ref="imgFileInput" hidden type="file" />
              </div>
            </div>
            <div class="fnItem" v-if="initialData.is_video">
              <div class="itemPosition" @click="videoStart">
                <svg-icon icon-class="video"></svg-icon>
                <p class="itemName">拍摄</p>
                <input type="file" accept="video/*" @change="uploadVideo" ref="videoInput" v-show="false" capture="camcorder" />
              </div>
            </div>
            <div class="fnItem" v-if="initialData.is_evaluat">
              <div class="itemPosition" @click="toEvaluate">
                <svg-icon icon-class="thumb"></svg-icon>
                <p class="itemName">评价</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="evaluate-pannel" v-if="showEvaluatePannel && initialData.is_evaluat">
        <div class="evaluate-container">
          <div class="evaluate-title">
            <div style="width: 70%;margin: 15px auto 0;" v-if="initialData.calling_config.evaluate_auto === '1'">{{initialData.calling_config.evaluate_content}}</div>
            <svg-icon @click.native="closeEvaluatePannel" class="evaluate-pannel-close" icon-class="closeBlack"></svg-icon>
          </div>
          <div class="evaluate-level clearfix">
            <div @click="setEvaluateLevel('1')">
              <div>
                <svg-icon v-if="evaluateLevel == '1'" icon-class="evaluateWorseActive" style="width: 28px;
                margin-bottom: 8px;height: 28px;margin: 0;"></svg-icon>
                <svg-icon v-else icon-class="evaluateWorse" style="width: 28px;
                margin-bottom: 8px;height: 28px;margin: 0;"></svg-icon>
              </div>
            </div>
            <div @click="setEvaluateLevel('2')">
              <div>
                <svg-icon v-if="evaluateLevel == '2'" icon-class="evaluateLessActive" style="width: 28px;
                margin-bottom: 8px;height: 28px;margin: 0;"></svg-icon>
                <svg-icon v-else icon-class="evaluateLess" style="width: 28px;
                margin-bottom: 8px;height: 28px;margin: 0;"></svg-icon>
              </div>
            </div>
            <div @click="setEvaluateLevel('3')">
              <div>
                <svg-icon v-if="evaluateLevel == '3'" icon-class="evaluateNormalActive" style="width: 28px;
                margin-bottom: 8px;height: 28px;margin: 0;"></svg-icon>
                <svg-icon v-else icon-class="evaluateNormal" style="width: 28px;
                margin-bottom: 8px;height: 28px;margin: 0;"></svg-icon>
              </div>
            </div>
            <div @click="setEvaluateLevel('4')">
              <div>
                <svg-icon v-if="evaluateLevel == '4'" icon-class="evaluateSatisfiedActive" style="width: 28px;
                margin-bottom: 8px;height: 28px;margin: 0;"></svg-icon>
                <svg-icon v-else icon-class="evaluateSatisfied" style="width: 28px;
                margin-bottom: 8px;height: 28px;margin: 0;"></svg-icon>
              </div>
            </div>
            <div @click="setEvaluateLevel('5')">
              <div>
                <svg-icon v-if="evaluateLevel == '5'" icon-class="evaluateVeryActive" style="width: 28px;
                margin-bottom: 8px;height: 28px;margin: 0;"></svg-icon>
                <svg-icon v-else icon-class="evaluateVery" style="width: 28px;
                margin-bottom: 8px;height: 28px;margin: 0;"></svg-icon>
              </div>
            </div>
          </div>
          <div class="evaluate-level-name">
            <span class="very" v-if="evaluateLevel == 5">
              <svg-icon icon-class="eval-very"></svg-icon>非常满意
            </span>
            <span class="satisfied" v-if="evaluateLevel == 4">
              <svg-icon icon-class="eval-satisfied"></svg-icon>比较满意
            </span>
            <span class="normal" v-if="evaluateLevel == 3">
              <svg-icon icon-class="eval-normal"></svg-icon>一般
            </span>
            <span class="less" v-if="evaluateLevel == 2">
              <svg-icon icon-class="eval-less"></svg-icon>比较不满意
            </span>
            <span class="worse" v-if="evaluateLevel == 1">
              <svg-icon icon-class="eval-worse"></svg-icon>非常不满意
            </span>
          </div>
          <div class="evaluate-quick-content clearfix" :class="renderLevelClass(evaluateLevel)">
            <span @click="chooseEval(item)" v-for="(item, index) in evaluateItem" :class="renderActiveClass(item)" :key="index">{{item.evaluateTagName}}</span>
            <span @click="toggleClick" :class="customEval ? 'tagActive' : ''">写评价</span>
          </div>
          <div class="evaluate-content-wrap" v-if="customEval">
            <textarea class="evaluate-content" v-model="evaluateContent" rows="2" placeholder="请填写评价内容（选填）" id></textarea>
          </div>
          <div class="evaluate-submit">
            <span @click="sendEvaluate" :class="(evaluateLevel != '0' && !evaluateSubmitted) ? '' : 'btnDisabled'">提交评价</span>
          </div>
        </div>
      </div>
    </div>
    <!--    聊天 end-->

    <!--    留言 start-->
    <div class="leave-msg-container" v-if="chatShow === 'leaveMsg'">
      <div class="chat-header clearfix">
        <div class="h-service-wrap clearfix">
          <div class="h-service-nickname">给我们留言</div>
        </div>
        <div class="h-page-handler-wrap clearfix">
          <div class="h-page-handler-item">
            <svg-icon icon-class="close" style="width: 13px;" @click.native="closeBtn"></svg-icon>
          </div>
        </div>
      </div>
      <div class="leave-msg-main">
        <div class="leave-msg-tips" v-if="initialData.calling_config">{{initialData.calling_config.message_tip}}</div>
        <div class="form-item">
          <p class="item-title">
            <span>*</span>手机:
          </p>
          <input v-model="mobile" class="item-content" type="text" />
        </div>
        <div class="form-item">
          <p class="item-title">邮箱:</p>
          <input v-model="email" class="item-content" type="text" />
        </div>
        <div class="form-item">
          <p class="item-title">
            <span>*</span>问题描述:
          </p>
          <textarea v-model="content" class="item-content problem-detail" type="text"></textarea>
        </div>
        <div class="leave-msg-submit">
          <span :class="leaveMsgSubmitted ? 'btnDisabled' : ''" @click="submitLeaveMsg">提交留言</span>
          <div>
            <div style="margin-top: 8px;padding: 5px 0;display: inline-block;font-size: 12px;color: #3396fa;" @click="viewHistory">查看聊天记录</div>
          </div>
        </div>
      </div>
    </div>
    <!--    留言 end-->

    <!--    排队 start-->
    <div class="lineup-container" v-if="chatShow === 'lineup'">
      <div class="chat-header clearfix">
        <div class="h-service-wrap clearfix">
          <div class="h-service-nickname">排队等待中...</div>
        </div>
        <div class="h-page-handler-wrap clearfix">
          <div class="h-page-handler-item">
            <svg-icon icon-class="close" style="width: 13px;" @click.native="closeBtn"></svg-icon>
          </div>
        </div>
      </div>
      <div class="lineup-main">
        <div class="lineup-tips">{{lineup.obj.remark}}</div>
        <div class="lineup-count">
          <div class="count-tips">当前您排在第</div>
          <div class="count-num">
            {{lineup.obj.queue_up_num + 1}}
            <span>位</span>
          </div>
        </div>
        <div class="lineup-operation">
          <div>如果等不及，可以选择</div>
          <div class="to-leave-msg-btn" @click="toLeaveMsg">给我们留言</div>
          <div>
            <div style="margin-top: 8px;padding: 5px 0;display: inline-block;font-size: 12px;color: #3396fa;" @click="viewHistory">查看聊天记录</div>
          </div>
        </div>
      </div>
    </div>
    <!--    排队 end-->
    <!--    <van-dialog-->
    <!--      title="修改地址"-->
    <!--      v-model="showPopup"-->
    <!--      v-if="showPopup"-->
    <!--      class="visitorAddressDialog"-->
    <!--      show-cancel-button-->
    <!--      @confirm="confirmHandler"-->
    <!--    >-->
    <van-action-sheet class="visitorAddressDialog" v-model="showPopup" round v-if="showPopup" title="请选择要修改的地址">
      <van-radio-group v-model="addr">
        <van-radio v-for="(list, index) in addrList" :name="list" :key="index" checked-color="#07c160">
          <div class="addressItemContainer">
            <div class="clearfix userInfo">
              <div class="userName">{{list.name}}</div>
              <div class="userMobile">{{list.mobile}}</div>
            </div>
            <div>{{list.address_detail}}</div>
          </div>
        </van-radio>
      </van-radio-group>
      <div class="confirmBtn" @click="confirmHandler">提交</div>
    </van-action-sheet>
    <!--    </van-dialog>-->
  </div>
</template>

<script>
  import VueEmoji from "@/libs/emoji/Emoji";
  import emojiData from "@/libs/emoji/emoji-data";
  import InitAvatar from "@/assets/images/avatar/client_avatar.png";

  import Recorder from "../../libs/record/recorder.mp3.min.js";

  export default {
    name: "mob-index",
    data() {
      return {
        uploadPrgressTimer: null,
        addr: "",
        orderId: "",
        callingId: "",
        addrList: [],
        showPopup: false,
        rec: null, // 录音
        recTimer: null, // 录音定时器
        recTimeTmp: 0, // 录音计时
        chatShow: "chat", // 默认显示会话界面
        showEmoji: false, // 表情面板
        showMoreFn: false, // 「更多」功能面板
        serviceAvatar: InitAvatar, // 客服头像
        serviceName: "连接中，请稍后...", // header文案，连接成功后 显示客服的昵称
        agent_sign: "",
        textarea: "", // 发送的消息内容
        messageHistory: false, // 是否显示加载更多
        isLoading: false, // 加载更多 -加载中
        chatWithService: true, // 显示聊天输入框
        chatend: false, // 对话结束
        isBlack: false, // 被加入黑名单
        isText: true, // 默显示文本输入框
        evaluateLevel: "5", // 评价等级
        evaluateContent: "", // 评价内容
        mobile: "", // 留言-手机号
        email: "", // 留言-邮箱
        content: "", // 留言-内容
        showEvaluatePannel: false, // 显示评价面板
        leaveMsgSubmitted: false, // 留言已提交
        evaluateSubmitted: false, // 评价已提交
        showSendBtn: false, // 发送按钮
        noMoreFunc: false, // 更多按钮
        showSendGoods: true, // 发送商品样式，默认展示
        nullForesee: true, // 空消息预知（允许一次）
        msgContent: "", // 消息内容
        agentUid: "", // 客服id
        currentPage: 1, // 查询历史-分页
        pageSize: 10, // 查询历史-每页显示条数
        viewHisMessageId: "",
        showMore: false,
        evaluateItem: [],
        chooseEvaluate: [],
        quickEvaluate: {},
        customEval: false,
        quickGuideList: []
      };
    },
    filters: {
      formateDateTime: val => {
        let date = new Date(val * 1000); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + ".";
        let M =
          (date.getMonth() + 1 < 10 ?
            "0" + (date.getMonth() + 1) :
            date.getMonth() + 1) + ".";
        let D =
          (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        // let h = date.getHours() + ':'
        // let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
        // let s = date.getSeconds()
        return Y + M + D;
        // return Y + M + D + h + m + s
      }
    },
    components: {
      VueEmoji
    },
    computed: {
      websocket() {
        return this.$store.state.ws;
      },
      loginInfo() {
        return this.$store.state.loginInfo;
      },
      messages() {
        // this.scrollToBottom()
        return this.$store.state.messages;
      },
      sayMsg() {
        return this.$store.state.sayMsg;
      },
      chatClose() {
        return this.$store.state.chatClose;
      },
      inviteEvaluation() {
        return this.$store.state.inviteEvaluation;
      },
      blackClose() {
        return this.$store.state.blackClose;
      },
      leaveMsg() {
        return this.$store.state.leaveMsg;
      },
      lineup() {
        return this.$store.state.lineup;
      },
      autoTurnManual() {
        return this.$store.state.autoTurnManual;
      },
      switching() {
        return this.$store.state.switching;
      },
      login() {
        return this.$store.state.login;
      },
      initialData() {
        return this.$store.state.initialData;
      },
      isiOS() {
        return this.$store.state.isiOS;
      },
      isWechat() {
        return this.$store.state.isWechat;
      },
      wxVoiceConfig() {
        return this.$store.state.wx;
      }
    },
    watch: {
      initialData: {
        handler(val) {
          if (val.calling_config.message_content_open === "1") {
            this.content = val.calling_config.message_content;
          }
          if (val.is_upload || val.is_video) {
            this.showSendBtn = false;
            this.noMoreFunc = true;
          } else {
            this.showSendBtn = true;
            this.noMoreFunc = false;
          }
        },
        deep: true
      },
      msgContent: {
        handler(val) {
          this.msgForesee(val);
          this.sendContent();
        },
        deep: true
      },
      loginInfo: {
        handler(val) {
          if (val) {
            this.serviceAvatar = this.loginInfo.agent_avatar || InitAvatar;
            this.serviceName = this.loginInfo.agent_nickname;
            this.agent_sign = this.loginInfo.agent_sign;
            this.agentUid = this.loginInfo.agent_uid;
            for (let uid in val.chats) {
              this.chatShow = "chat";
              this.messageHistory = val.chats[uid].messages_history;
              this.scrollToBottom();
            }
          }
        },
        deep: true
      },
      sayMsg: {
        handler(val) {
          this.scrollToBottom();
        },
        deep: true
      },
      messages: {
        handler(val) {
          val.forEach(item => {
            if (item.sensitiveword) {
              this.msgForesee('');
            }
          })
          this.$previewRefresh();
        },
        deep: true
      },
      login: {
        handler(val) {
          this.serviceAvatar = this.loginInfo.agent_avatar || InitAvatar;
          this.serviceName = this.loginInfo.agent_nickname;
          this.agent_sign = this.loginInfo.agent_sign;
          this.agentUid = this.loginInfo.agent_uid;
          this.scrollToBottom();
          // this.$utils.isShowMsgTime(true)
        },
        deep: true
      },
      switching: {
        handler(val) {
          this.serviceAvatar = val.agent_avatar || InitAvatar;
          this.serviceName = val.agent_name;
          this.agent_sign = val.agent_sign;
          this.agentUid = val.from_uid;
        },
        deep: true
      },
      chatClose: {
        handler(val) {
          this.showEmoji = false;
          this.showMoreFn = false;
          this.chatWithService = false;
          this.chatend = true;
          this.isBlack = false;
          this.showEvaluatePannel = true;
        },
        deep: true
      },
      inviteEvaluation: {
        handler(val) {
          if (!this.evaluateSubmitted) {
            this.showEvaluatePannel = true;
          }
        },
        deep: true
      },
      blackClose: {
        handler(val) {
          this.showEmoji = false;
          this.showMoreFn = false;
          this.chatWithService = false;
          this.chatend = false;
          this.isBlack = true;
          this.showEvaluatePannel = false;
        },
        deep: true
      },
      leaveMsg: {
        handler(val) {
          this.chatShow = "leaveMsg";
        },
        deep: true
      },
      lineup: {
        handler(val) {
          if (val && val.lineup) {
            this.chatShow = "lineup";
          }
        },
        deep: true
      },
      autoTurnManual: {
        handler(val) {
          this.robotTurnManual();
        },
        deep: true
      }
    },
    created() {
      this.scrollToBottom();
      this.getQuickEvaluate();
      this.getPageTitle();
      this.getVisitorQuickGuide();
      // 解决ios返回上一页不刷新页面
      let u = navigator.userAgent;
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isIOS) {
        window.onpageshow = function(e) {
          if (e.persisted || (window.performance && window.performance.navigation.type == 2)) {
            window.location.reload()
          }
        }
      }
    },
    mounted() {
      eventBus.$on("waitend", () => {
        this.chatShow = "chat";
      });
      let _this = this;
      this.$nextTick(function() {
        setTimeout(() => {
          _this.getInitialData()
        })
      })
      document.addEventListener(
        "click",
        function() {
          // 机器人常见问题选择
          document.querySelectorAll(".j-send-problem").forEach((item, i) => {
            item.onclick = function() {
              let newMessage = {
                type: "say",
                sendtime: "" + _this.$utils.getTimes(),
                from_uid: _this.loginInfo.client_uid,
                to_uid: _this.loginInfo.agent_uid,
                // 'showtime': this.$utils.isShowMsgTime(false, _this.$utils.getTimes()),
                role: "client",
                msg_type: "text",
                text: this.innerText
              };
              if (_this.websocket.readyState === 1) {
                _this.renderMsg(newMessage);
              }
            };
          });
          // 转人工
          if (document.querySelector(".js_manual")) {
            document.querySelector(".js_manual").onclick = function() {
              _this.robotTurnManual();
            };
          }

          // 去留言
          if (document.querySelector(".js_to_leaveMsg")) {
            document.querySelector(".js_to_leaveMsg").onclick = function() {
              _this.chatShow = "leaveMsg";
            };
          }
          // 已解决
          if (document.querySelector(".js_settled")) {
            document.querySelectorAll(".js_settled").forEach(function(item, index) {
              item.onclick = function() {
                let vId = this.getAttribute("data-visitId");
                let callingId = this.getAttribute("data-callingId");
                _this.robotEvaluate(1, vId, callingId);
              };
            })
          }
          // 未解决
          if (document.querySelector(".js_no_settled")) {
            document.querySelectorAll(".js_no_settled").forEach(function(item, index) {
              item.onclick = function() {
                let vId = this.getAttribute("data-visitId");
                let callingId = this.getAttribute("data-callingId");
                _this.robotEvaluate(0, vId, callingId);
              };
            })
          }
        },
        true
      );

      let set = {
        type: "mp3", // 输出类型：mp3,wav等，使用一个类型前需要先引入对应的编码引擎
        bitRate: 16, // 比特率 wav(位):16、8，MP3(单位kbps)：8kbps时文件大小1k/s，16kbps 2k/s，录音文件很小

        sampleRate: 48000, // 采样率，wav格式文件大小=sampleRate*时间；mp3此项对低比特率文件大小有影响，高比特率几乎无影响。
        // wav任意值，mp3取值范围：48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000

        bufferSize: 4096 // AudioContext缓冲大小。会影响onProcess调用速度，相对于AudioContext.sampleRate=48000时，4096接近12帧/s，调节此参数可生成比较流畅的回调动画。
        // 取值256, 512, 1024, 2048, 4096, 8192, or 16384
        // 注意，取值不能过低，2048开始不同浏览器可能回调速率跟不上造成音质问题（低端浏览器→说的就是腾讯X5）
      };
      if (!this.isWechat && !this.isiOS) {
        // 在安卓-非微信环境使用
        this.rec = window.Recorder(set);
      }
      this.scrollToBottom();
      // this.readServiceNews() // 暂时不做
    },
    updated() {
      let that = this;
      this.$nextTick(function() {
        let $inputs = Array.from(document.getElementsByTagName("input"));
        let body = document.body;
        $inputs.forEach(item => {
          item.onblur = function() {
            // onblur是核心方法
            window.scroll(0, 0);
          };
        });
      });
    },
    methods: {
      /**
       * 商品跳转
       */
      linkToGoods(item) {
        if (this.$utils.GetQueryString("source") === "mmk") {
          //目前仅 针对 麦麦看项目
          setTimeout(() => {
            //  跳转到商品详情页，携带商品goodsId
            uni.navigateTo({
              url: "/pages/goods/detail/index?goodsId=" + item.itemid
            });
          }, 500);
        } else {
          window.open(item.link, "_blank");
        }
      },
      /**
       * 订单跳转
       * 目前仅 针对 麦麦看项目
       */
      linkToOrder(item) {
        if (this.$utils.GetQueryString("source") === "mmk") {
          setTimeout(() => {
            //  跳转到商品详情页，携带商品goodsId
            uni.navigateTo({
              url: "/pages/order/detail/index?orderId=" + item
            });
          }, 500);
        }
      },
      confirmHandler() {
        if (this.addr.address.length == 0) {
          this.showPopup = true;
          this.$toast.fail("请选择要修改的地址！");
          return false;
        }
        this.confirmAddr(this.orderId, this.callingId, 0, this.addr);
      },
      editAddr(orderId, callingId) {
        this.addr = "";
        this.orderId = orderId;
        this.callingId = callingId;
        this.$http
          .getAddressAPI({
            companyId: Number(this.$utils.GetQueryString("cid")),
            visitorId: this.$store.state.loginInfo.client_uid,
            orderId: orderId
          })
          .then(res => {
            if (res.status == 1) {
              this.showPopup = true;
              this.addrList = res.data;
            }
          });
      },
      confirmAddr(orderId, callingId, state, addrInfo,name,mobile) {
        let postParams = {
          companyId: this.$utils.GetQueryString("cid"),
          address: addrInfo.address_detail || addrInfo,
          mobile: addrInfo.mobile || mobile,
          name: addrInfo.name || name,
          callingId: callingId,
          state: state,
          orderId: orderId
        };
        this.$http.confirmAddressAPI(postParams).then(res => {
          if (res.status == 1) {
            this.$toast(res.msg);
            this.$nextTick(() => {
              this.$store.dispatch("_clearMsg");
              eventBus.$emit("addrConfirm");
            });
          } else {
            this.$toast.fail(res.msg);
          }
          this.showPopup = false;
        });
      },
      robotEvaluate(type, vId, callingId) {
        this.$http
          .robotEvaluateAPI({
            type: type,
            visitorId: vId
          })
          .then(res => {
            if (res.status == 1) {
              this.messages.map(item => {
                if (item.callingId == callingId) {
                  if (type == 1) {
                    item.handler = "已解决";
                  } else {
                    item.handler = "未解决";
                  }
                }
              });
            }
          });
      },
      returnBack() {
        this.$store.dispatch("_clearMsg");
        this.chatShow = sessionStorage.getItem("chatShow");
      },
      viewHistory() {
        this.$store.dispatch("_clearMsg");
        sessionStorage.setItem("chatShow", this.chatShow);
        this.$http
          .viewHisChatDataAPI({
            cid: this.$utils.GetQueryString("cid"),
            visitorId: this.loginInfo.client_uid
          })
          .then(res => {
            let loginChats = res.data;
            let messageArr = [];
            for (let uid in loginChats.chats) {
              this.serviceName = "当前暂无客服在线";
              messageArr = loginChats.chats[uid].messages;
              this.currentPage = 1;
              this.pageSize = 10;
              this.messageHistory = loginChats.chats[uid].messages_history;
              this.viewHisMessageId = loginChats.chats[uid].messages_id;
            }
            if (messageArr.length > 0) {
              messageArr.map(item => {
                this.$store.dispatch("_updateMsg", item);
              });
            } else {
              this.$toast.fail("暂无聊天记录");
              return false;
            }

            this.chatShow = "viewHis";
          });
      },
      renderOrderStatusClass(status) {
        return "order-status" + status;
      },
      renderOrderStatus(status) {
        switch (status) {
          case 0:
          case "0":
            return "待付款";
          case 1:
          case "1":
            return "待发货";
          case 2:
          case "2":
            return "待收货";
          case 3:
          case "3":
            return "交易成功";
          case 4:
          case "4":
            return "订单关闭";
          case 5:
          case "5":
            return "卖家同意退/换货";
          case 6:
          case "6":
            return "退/换货中";
        }
      },
      whiteIconClass(type) {
        switch (type) {
          case "image":
          case "goods":
          case "video":
            return "whiteIconClass";
          default:
            return "";
        }
      },
      // 发送商品连接
      sendGoodsLink(goods) {
        let sendGoods = {
          type: "say",
          sendtime: "" + this.$utils.getTimes(),
          from_uid: this.loginInfo.client_uid,
          // 'showtime': this.$utils.isShowMsgTime(false, this.$utils.getTimes()),
          to_uid: this.agentUid,
          role: "client",
          msg_type: "goods",
          text: goods
        };
        if (this.websocket.readyState === 1) {
          this.renderMsg(sendGoods);
          this.showSendGoods = false;
        } else {
          this.$toast.fail("消息发送失败");
        }
      },
      // 消息预知
      msgForesee(msg) {
        if (this.initialData.is_foresee) {
          let foreseeMsg = {
            type: "foresee",
            sendtime: "" + this.$utils.getTimes(),
            from_uid: this.loginInfo.client_uid,
            to_uid: this.agentUid,
            role: "client",
            msg_type: "foresee",
            text: msg.trim()
          };
          // if (msg.trim().length === 0) {
          //   this.$nextTick(() => {
          //     this.nullForesee = false;
          //   });
          // } else {
          //   this.nullForesee = true;
          // }
          if (this.nullForesee) {
            this.websocket.send(
              JSON.stringify({
                foresee: {
                  message: foreseeMsg
                }
              })
            );
          }
        }
      },
      /**
       * 【显示表情】
       */
      formatTrendEmoji(val) {
        let sName = val;
        let sImg = [];
        let rules = /:([^:][a-z_\-]+):/g;
        if (sName) {
          sName.replace(rules, function($1, $2) {
            sImg.push($2);
          });
          for (let i = 0; i < sImg.length; i++) {
            let str = "";
            let rStr = ":" + sImg[i] + ":";
            for (let key in emojiData) {
              if (sImg[i] === key) {
                let imgPath = require(`@/libs/emoji/images/${sImg[i]}.gif`);
                str = sName.replace(
                  rStr,
                  `<img style="display: inline-block;max-width: 24px;max-height: 24px;" src="` +
                  imgPath +
                  `" class="img">`
                );
              } else {
                str = sName.replace(rStr, rStr);
              }
              sName = str;
            }
          }
        }
        return sName;
      },
      /**
       * 查看更多历史消息
       * */
      loadHistory() {
        let postParam = {
          currentPage: this.currentPage, // 当前页
          pageSize: this.pageSize, // 每页行数
          companyId: this.$utils.GetQueryString("cid"), //  企业id
          agentUid: this.loginInfo.agent_uid, //  企业所属代理商id（0 代表启博 >0代表代理商）
          visitorId: this.loginInfo.client_uid, //  访客Id
          messagesId: this.viewHisMessageId ||
            this.loginInfo.chats[this.loginInfo.client_uid].messages_id,
          endTime: ""
        };
        this.isLoading = true;
        this.$http.getHistoryAPI(postParam).then(res => {
          this.isLoading = false;
          if (res.status === "1") {
            let oldHeight = this.$refs.detailCont.scrollHeight;
            res.data.reverse().map(item => {
              this.$store.dispatch("_loadHistoryMsg", item);
            });
            this.$nextTick(() => {
              // this.$refs.detailCont.scrollTop = this.$refs.detailCont.scrollHeight - oldHeight;
            });
            if (res.data.length < this.pageSize) {
              this.messageHistory = false;
            } else {
              this.currentPage = this.currentPage + 1;
            }
          }
        });
      },
      /**
       * 聊天内容滚动到底部
       * */
      scrollToBottom() {
        this.$nextTick(() => {
          this.$refs.detailCont.scrollTop = this.$refs.detailCont.scrollHeight;
        });
      },
      getQuickEvaluate() {
        this.$http.getQuickEvaluateAPI({
          cid: this.$utils.GetQueryString("cid")
        }).then(res => {
          if (res.status == 1) {
            this.quickEvaluate = res.data;
            this.evaluateItem = res.data[this.evaluateLevel];
          }
        });
      },
      /**
       * 播放语音
       * @param event
       */
      voicePlay(e) {
        let _this = this;
        let event = e.currentTarget;
        let symbolVoice = event.getElementsByClassName("wifi-symbol")[0];
        let audioId = event.getElementsByClassName("audioId")[0];
        let parentBox = event.parentNode;

        if (this.$utils.hasClass(parentBox, "voicing")) {
          this.$utils.removeClass(parentBox, "voicing");
          audioId.pause(); // 暂停-从头播放
          audioId.currentTime = 0;
          this.$utils.removeClass(symbolVoice, "bofang");
        } else {
          document.querySelectorAll(".bubble").forEach(function(item, i) {
            _this.$utils.removeClass(item, "voicing");
          });
          document.querySelectorAll(".wifi-symbol").forEach(function(item, i) {
            _this.$utils.removeClass(item, "bofang");
          });
          document
            .querySelectorAll("audio")
            .forEach(function(audioItem, audioIndex) {
              audioItem.pause();
              audioItem.currentTime = 0;
            });

          this.$utils.addClass(parentBox, "voicing");
          if (this.$utils.hasClass(symbolVoice, "bofang")) {
            audioId.pause(); // 暂停-从头播放
            audioId.currentTime = 0;
            this.$utils.removeClass(symbolVoice, "bofang");
          } else {
            audioId.play();
            this.$utils.addClass(symbolVoice, "bofang");
          }
        }
        // 播放完后执行
        audioId.addEventListener(
          "ended",
          function() {
            _this.$utils.removeClass(symbolVoice, "bofang");
          },
          false
        );
      },
      watchVideoPlay(e) {
        let _event = e.currentTarget;
        var poster = _event.parentNode.parentNode.getElementsByClassName("poster")[0];
        var videoMask = _event.parentNode.parentNode.getElementsByClassName("video-mask")[0];
        videoMask.style.display = "none";
        _event.classList.add("play")
        poster.classList.add("play")
      },
      watchVideoPause(e) {
        let _event = e.currentTarget;
        var poster = _event.parentNode.parentNode.getElementsByClassName("poster")[0];
        _event.classList.remove("play")
        poster.classList.remove("play")
        document.querySelectorAll(".video-mask").forEach(function(item, i) {
          item.style.display = "block";
        });
      },
      watchVideoEnded(e) {
        let _event = e.currentTarget;
        var poster = _event.parentNode.parentNode.getElementsByClassName("poster")[0];
        _event.classList.remove("play")
        poster.classList.remove("play")
        document.querySelectorAll(".video-mask").forEach(function(item, i) {
          item.style.display = "block";
        });
        _event.currentTime = 0;
      },
      /**
       * 视频暂停
       * @param e
       */
      videoStop(e) {
        let _event = e.currentTarget;
        let videoId = _event.parentNode.getElementsByClassName("videoId")[0];
        videoId.pause();
        videoId.currentTime = 0;
      },
      /**
       * 视频播放
       * @param e
       */
      videoPlay(e) {
        var _event = e.currentTarget;
        var videoId = _event.parentNode.parentNode.getElementsByClassName(
          "videoId"
        )[0];
        document.querySelectorAll("video").forEach(function(item, i) {
          item.pause();
          item.currentTime = 0;
        });
        videoId.play()
      },
      /**
       * 发送图片
       */
      imageClick() {
        this.$refs.imgFileInput.click();
      },
      uploadImageOrVideo(e) {
        let file = e.target.files[0];
        let type = file.type.split("/")[0];
        if (type == "image") {
          this.uploadImage(e)
        } else if (type == "video") {
          this.uploadVideo(e)
        } else {
          this.$toast.fail("请选择图片或者视频上传，建议上传30M以下的视频");
        }
      },
      uploadImage(e) {
        let img = e.target.files[0];
        let size = img.size;
        let maxSize = 3 * 1024 * 1024;
        if (size > maxSize) { // 大于3M压缩
          let _this = this;
          _this.$toast.loading({
            duration: 0
          })
          _this.$utils.resizeImage(img, maxSize).then(function(result) {
            return typeof result === 'string' ? _this.$utils.convertToBlob(result, img.type) : result;
          }).then(function(blob) {
            let formData = new FormData();
            //注意：此处第3个参数最好传入一个带后缀名的文件名，否则很有可能被后台认为不是有效的图片文件
            formData.append("file", blob, img.name);
            _this.$toast.clear()
            _this.sendImage(formData);
          });
        } else {
          let name = img.name;
          let type = name.substring(name.lastIndexOf("."));
          name = name.substring(0, name.lastIndexOf("."));
          let uploadFile = new File([img], new Date().getTime() + type, {
            size: size,
            type: img.type
          });
          let formdata = new FormData();
          formdata.set("file", uploadFile);
          this.sendImage(formdata);
        }
      },
      /**
       * 发送视频
       */
      videoStart() {
        let _this = this;
        this.$dialog.confirm({
          title: '提示',
          message: '建议拍摄10秒以下的视频，视频过大会导致上传失败。如果出现上传失败请先到系统设置-相机设置降低视频画质再拍摄上传。'
        }).then(() => {
          _this.$refs.videoInput.click()
          _this.$dialog.close()
        }).catch(() => {

        });
      },
      uploadVideo(e) {
        let file = e.target.files[0];
        let formdata = new FormData();
        formdata.set("file", file);
        this.sendVideo(formdata);
      },
      /**
       * 去留言
       */
      toLeaveMsg() {
        this.chatShow = "leaveMsg";
      },
      /**
       *继续会话
       */
      chatReload() {
        window.location.reload();
      },
      /**
       * 满意度
       */
      toEvaluate() {
        this.showEvaluatePannel = true;
      },
      setEvaluateLevel(val) {
        this.evaluateItem = this.quickEvaluate[val];
        this.evaluateLevel = val;
        this.chooseEvaluate = [];
      },
      renderLevelClass(val) {
        switch (val) {
          case "1":
          case 1:
            return "wrapWorse";
          case "2":
          case 2:
            return "wrapLess";
          case "3":
          case 3:
            return "wrapNormal";
          case "4":
          case 4:
            return "wrapSatisfied";
          case "5":
          case 5:
            return "wrapVery";
        }
      },
      renderActiveClass(item) {
        if (this.chooseEvaluate.indexOf(item) > -1) {
          return "tagActive";
        }
      },
      toggleClick() {
        this.customEval = !this.customEval;
      },
      chooseEval(item) {
        if (this.chooseEvaluate.indexOf(item) > -1) {
          this.chooseEvaluate.splice(this.chooseEvaluate.indexOf(item), 1);
        } else {
          this.chooseEvaluate.push(item);
        }
      },
      closeEvaluatePannel() {
        this.showEvaluatePannel = false;
      },
      /**
       * 切换-发送语音
       */
      toRecord() {
        this.isText = false;
        this.showEmoji = false;
        this.showMoreFn = false;
      },
      /**
       * 切换-发送文字
       */
      toText() {
        this.isText = true;
        this.$nextTick(() => {
          this.$refs.textInput.focus();
        });
      },
      // 展示「更多」功能
      showMoreFunction() {
        this.showMoreFn = !this.showMoreFn;
        this.showEmoji = false;
        this.isText = true;
      },
      sendContent() {
        if (this.noMoreFunc) {
          if (this.msgContent.trim().length > 0) {
            this.showSendBtn = true;
          } else {
            this.showSendBtn = false;
          }
        }
      },
      // 提交评价
      sendEvaluate() {
        if (!this.evaluateSubmitted) {
          if (this.evaluateLevel === "0") {
            this.$toast.fail("请先选择评价等级");
            return false;
          }
          if (!this.customEval) {
            this.evaluateContent = "";
          }
          let tagIds = [];
          this.chooseEvaluate.map(item => {
            tagIds.push(item.id);
          });
          let postData = {
            visitorId: this.loginInfo.client_uid,
            servicerId: this.loginInfo.agent_uid,
            grade: Number(this.evaluateLevel),
            content: this.evaluateContent,
            tagIds: tagIds,
            cid: this.$utils.GetQueryString("cid"),
            csid: ""
          };
          this.$http.chatEvaluateAPI(postData).then(res => {
            if (res.status === "1") {
              this.evaluateSubmitted = true;
              this.showEvaluatePannel = false;
              this.$toast.success(res.msg);
            } else {
              this.$toast.fail(res.msg);
            }

          });
        }
      },
      // 提交-留言
      submitLeaveMsg() {
        if (this.mobile.trim().length === 0) {
          this.$toast.fail("手机号不能为空");
          return false;
        }
        if (this.content.trim().length === 0) {
          this.$toast.fail("内容不能为空");
          return false;
        }
        let postData = {
          visitorId: this.loginInfo.client_uid,
          mobile: this.mobile,
          content: this.content,
          email: this.email,
          cid: this.$utils.GetQueryString("cid"),
          csid: ""
        };
        if (!this.leaveMsgSubmitted) {
          this.$http.chatLeaveMsgAPI(postData).then(res => {
            if (res.status === "1") {
              this.leaveMsgSubmitted = true;
            }
            this.$toast.fail(res.msg);
          });
        }
      },
      /**
       * 【发送表情】
       */
      // 点击显示/隐藏表情弹框
      showEmojiFn(event) {
        // event.stopPropagation()
        this.isText = true;
        this.showEmoji = !this.showEmoji;
        this.showMoreFn = false;
      },
      // 选择表情
      selectEmoji(emoji) {
        // document.getElementById('chatTextDiv').focus()
        const newEmoji = "[" + emoji.value[0] + "]";
        // this.showEmoji = false
        // this.sendBtn = false
        this.msgContent += newEmoji; // ':' + emoji.name + ':'
        // this.insertHtmlAtCaret(newEmoji)
      },
      // 发送成功后渲染消息
      renderMsg(msg) {
        this.websocket.send(JSON.stringify({
          say: {
            message: msg
          }
        }));
        window.vm.$store.dispatch("_updateMsg", msg);
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      },
      //  发送图片
      sendImage(img) {
        this.showMoreFn = false;
        this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: "spinner",
          message: "发送中..."
        });
        this.$http
          .sendImageMsgAPI(img)
          .then(res => {
            this.$toast.clear();
            if (res.status === "1") {
              let newMessage = {
                type: "say",
                sendtime: "" + this.$utils.getTimes(),
                from_uid: this.loginInfo.client_uid,
                to_uid: this.agentUid,
                // 'showtime': this.$utils.isShowMsgTime(false, this.$utils.getTimes()),
                role: "client",
                msg_type: "image",
                text: res.data
              };
              if (this.websocket.readyState === 1) {
                this.renderMsg(newMessage);
              } else {
                this.$toast.fail("消息发送失败");
              }
            } else {
              this.$toast.fail(res.msg);
            }
            // this.$nextTick(() => {
            //   this.$toast.clear()
            // })
          })
          .catch(() => {
            this.$toast.clear();
          });
      },
      clearUploadTimer() {
        this.$toast.clear();
        clearInterval(this.uploadPrgressTimer);
        this.$http.uploadProgressResetAPI();
      },
      // 发送视频消息
      sendVideo(file) {
        this.showMoreFn = false;
        this.uploadPrgressTimer = setInterval(() => {
          this.$http
            .uploadProgressAPI()
            .then(res => {
              this.$toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: "spinner",
                message: `发送中... ${typeof res=="object"?0:res}%`
              });
              if (res == 100) {
                this.clearUploadTimer();
              }
            })
            .catch(() => {
              this.clearUploadTimer();
            });
        }, 100);
        this.$http
          .sendVideoMsgAPI(file)
          .then(res => {
            this.clearUploadTimer();
            if (res.status === "success") {
              let newMessage = {
                type: "say",
                sendtime: "" + this.$utils.getTimes(),
                from_uid: this.loginInfo.client_uid,
                // 'showtime': this.$utils.isShowMsgTime(false, this.$utils.getTimes()),
                to_uid: this.agentUid,
                role: "client",
                msg_type: "video",
                text: res.data.videoUrl,
                reduced_graph: res.data.reducedImage,
                talk_time: res.data.time
              };
              if (this.websocket.readyState === 1) {
                this.renderMsg(newMessage);
              } else {
                this.$toast.fail("消息发送失败");
              }
            } else {
              this.$toast.fail(res.message);
            }
            // this.$nextTick(() => {
            //   this.$toast.clear()
            // })
          })
          .catch(() => {
            this.clearUploadTimer();
          });
      },
      enterSendMsg(e) {
        if (e.keyCode === 13 && e.ctrlKey) {
          this.textarea += "\n";
        } else if (e.keyCode === 13) {
          e.preventDefault();
          this.sendMsg();
        }
      },
      // 发送文本消息
      sendMsg(msg) {
        if (this.msgContent.trim().length === 0) {
          this.$toast.fail("消息内容不能为空");
          return false;
        }
        let _this = this;
        var partten = /\[(.+?)\]/g;
        if (this.msgContent.match(partten)) {
          this.msgContent.match(partten).forEach(function(item) {
            for (let key in emojiData) {
              var emojiCN = "[" + emojiData[key][0] + "]";
              var emojiEN = ":" + key + ":";
              var reg = new RegExp("\\[(" + emojiData[key][0] + ")\\]", "ig");
              if (item === emojiCN) {
                _this.msgContent = _this.msgContent.replace(
                  new RegExp(reg, "g"),
                  emojiEN
                );
              }
            }
          });
        }

        let newMessage = {
          type: "say",
          sendtime: "" + this.$utils.getTimes(),
          from_uid: this.loginInfo.client_uid,
          to_uid: this.agentUid,
          role: "client",
          // 'showtime': this.$utils.isShowMsgTime(false, this.$utils.getTimes()),
          msg_type: "text",
          text: this.msgContent
        };
        if (this.websocket.readyState === 1) {
          this.renderMsg(newMessage);
          this.showEmoji = false;
          this.$nextTick(() => {
            this.msgContent = "";
            this.$refs.textInput.focus();
          });
        } else {
          this.$toast.fail("消息发送失败");
        }
      },
      closeBtn() {
        this.$router.go(-1);
      },
      inputFocus() {
        this.showEmoji = false;
        this.showMoreFn = false;
        this.$refs.textInput.focus();
      },
      // 机器人转人工
      robotTurnManual() {
        let params = {
          cid: this.$cookie.get("cid"),
          uniquecode: this.$cookie.get("FENBOT_fingerprint"),
          choose: "human",
          toid: this.$utils.GetQueryString("toid"),
          csid: this.$utils.GetQueryString("csid"),
          uid: this.$utils.GetQueryString("uid"),
          type: this.$utils.GetQueryString("type"),
          source: this.$utils.GetQueryString("source")
        };
        this.$store.dispatch("_login", params, this.loginInfo.agent_uid);
      },
      //  语音（非微信中）
      uploadVoiceBrowser(file) {
        let voiceFile = new FormData();
        voiceFile.append("file", file, new Date().getTime() + ".mp3");
        this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: "spinner",
          message: "发送中..."
        });
        this.rec.close();
        this.$http.sendVoiceMsgAPI(voiceFile).then(res => {
          this.$toast.clear();
          if (res.status === "success") {
            let voiceMsg = {
              type: "say",
              sendtime: "" + this.$utils.getTimes(),
              from_uid: this.loginInfo.client_uid,
              to_uid: this.agentUid,
              role: "client",
              msg_type: "voice",
              // 'showtime': this.$utils.isShowMsgTime(false, this.$utils.getTimes()),
              text: res.data,
              talk_time: this.recTimeTmp
            };
            if (this.websocket.readyState === 1) {
              this.renderMsg(voiceMsg);
            } else {
              this.$toast.fail("消息发送失败");
            }
          } else {
            this.$toast.clear();
            this.$nextTick(() => {
              this.$toast.fail("消息发送失败");
            });
          }
        });
      },
      //  语音（微信中）
      uploadVoiceWechat(serverId) {
        let postData = {
          type: "voice",
          media_id: serverId,
          visitorId: this.loginInfo.client_uid
        };
        this.$http.getVoiceInfoAPI(postData).then(res => {
          if (res.status === 1) {
            let voiceMsg = {
              type: "say",
              sendtime: "" + this.$utils.getTimes(),
              from_uid: this.loginInfo.client_uid,
              to_uid: this.agentUid,
              // 'showtime': this.$utils.isShowMsgTime(false, this.$utils.getTimes()),
              role: "client",
              msg_type: "voice",
              talk_time: res.data.talk_time,
              text: res.data.url
            };
            if (this.websocket.readyState === 1) {
              this.renderMsg(voiceMsg);
            } else {
              this.$toast.fail("消息发送失败");
            }
          } else {
            this.$toast.fail("语音发送失败");
          }
        });
      },
      // 手指按住
      gtouchstart() {
        let _this = this;
        this.recTimeTmp = 0;
        if (this.isWechat) {
          // 在微信环境下
          this.$toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: "spinner",
            message: "正在录音，松开发送"
          });
          this.wxVoiceConfig.startRecord();
          this.recTimer = setInterval(() => {
            this.recTimeTmp = this.recTimeTmp + 1;
          }, 1000);
          this.wxVoiceConfig.onVoiceRecordEnd({
            // 录音时间超过一分钟没有停止的时候会执行 complete 回调
            complete: function(res) {
              let localId = res.localId;
              clearInterval(this.recTimer);
              // _this.$toast.loading({
              //   duration: 0, // 持续展示 toast
              //   forbidClick: true, // 禁用背景点击
              //   loadingType: 'spinner',
              //   message: '发送中...'
              // })
              _this.wxVoiceConfig.uploadVoice({
                localId: localId,
                success: function(res) {
                  let serverid = res.serverId;
                  // _this.$toast.clear()
                  _this.uploadVoiceWechat(serverid);
                },
                fail: function() {
                  _this.$toast.fail("语音发送失败");
                  // _this.$toast.clear()
                }
              });
            }
          });
        }
        if (!this.isWechat && !this.isiOS) {
          // 在安卓-非微信环境使用
          this.rec.open(
            () => {
              this.$toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: "spinner",
                message: "正在录音，松开发送"
              });

              this.rec.start();
              this.recTimer = setInterval(() => {
                this.recTimeTmp = this.recTimeTmp + 1;
                if (this.recTimeTmp > 58) {
                  clearInterval(this.recTimer);
                  this.rec.stop(
                    blob => {
                      // TODO 上传语音文件
                      this.uploadVoiceBrowser(blob);
                    },
                    err => {
                      clearInterval(this.recTimer);
                      this.recTimeTmp = 0;
                      this.rec.close(); // 释放录音资源
                      alert("出错：", err);
                    }
                  );
                }
              }, 1000);
            },
            () => {
              clearInterval(this.recTimer);
              this.recTimeTmp = 0;
              this.rec.close(); // 释放录音资源
            }
          );
        }
      },
      // 手指按住-移动
      gtouchmove() {},
      // 手指按住-松开
      gtouchend() {
        let _this = this;
        this.$toast.clear();
        clearInterval(this.recTimer);
        if (this.isWechat) {
          // 微信环境使用
          if (this.recTimeTmp === 0) {
            this.$toast.fail("说话时间太短");
            this.wxVoiceConfig.stopRecord({
              success: function(res) {}
            });
          } else {
            this.wxVoiceConfig.stopRecord({
              success: function(res) {
                var localId = res.localId;
                // _this.$toast.loading({
                //   duration: 0, // 持续展示 toast
                //   forbidClick: true, // 禁用背景点击
                //   loadingType: 'spinner',
                //   message: '发送中...'
                // })
                _this.wxVoiceConfig.uploadVoice({
                  localId: localId,
                  success: function(res) {
                    // _this.$toast.clear()
                    var serverid = res.serverId;
                    _this.uploadVoiceWechat(serverid);
                  },
                  fail: function() {
                    _this.$toast.fail("语音发送失败");
                    // _this.$toast.clear()
                  }
                });
              },
              fail: function() {
                _this.$toast.fail("语音发送失败");
              }
            });
          }
        }
        if (!this.isWechat && !this.isiOS) {
          // 在安卓-非微信环境使用
          if (this.recTimeTmp === 0) {
            this.$toast.fail("说话时间太短");
            this.rec.close(); // 释放录音资源
          } else {
            // TODO 上传语音文件
            this.rec.stop(
              blob => {
                // TODO 上传语音文件
                this.uploadVoiceBrowser(blob);
              },
              err => {
                clearInterval(this.recTimer);
                this.recTimeTmp = 0;
                this.rec.close(); // 释放录音资源
                alert("出错：", err);
              }
            );
          }
        }
      },
      // 手指按住-取消
      gtouchcancel() {
        this.$toast.clear();
        clearInterval(this.recTimer);
        this.recTimeTmp = 0;
        if (this.isWechat) {
          this.wxVoiceConfig.stopRecord({
            success: function(res) {}
          });
        }
        if (!this.isWechat && !this.isiOS) {
          // 在安卓-非微信环境使用
          this.rec.close(); // 释放录音资源
        }
      },
      /*
       * Author: wuzhiying
       * createTime: 2020.04.15 20:20
       */
      getPageTitle: function() {
        this.$http.getPageTitleAPI({
          cid: Number(this.$utils.GetQueryString("cid"))
        }).then(res => {
          if (res.status == 1) {
            document.title = res.data || '微聊客服'
          }
        })
      },
      getInitialData: function() {
        this.$http.getInitialDataAPI({
          cid: Number(this.$utils.GetQueryString("cid"))
        }).then(res => {
          console.log(res)
          if (res.status == 1) {
            document.getElementsByClassName("chat-header")[0].style.backgroundColor = res.data.calling_config.dialog_box_color
          }
        })
      },
      getVisitorQuickGuide: function() {
        this.$http.getVisitorQuickGuideAPI({
          cid: Number(this.$utils.GetQueryString("cid"))
        }).then(res => {
          console.log(res)
          if (res.status == 1) {
            this.quickGuideList = res.data
          }
        })
      },
      clickQuickGuide: function(item) {
        if (item.type == 1) {
          this.toEvaluate();
        } else {
          window.location.href = item.content;
        }
      },
      // 获取可视区域内所有客服消息并发送已读websocket
      readServiceNews() {
        let agentMsgArr = document.querySelectorAll(".agent-msg");
        let callingId_arr = []
        if (agentMsgArr.length) {
          agentMsgArr.forEach((item, index) => {
            if (this.isElementInViewport(item)) {
              if (item.getAttribute("data-callingId")) {
                console.log(item.getAttribute("data-isRead"))
                if (!item.getAttribute("data-isRead") == 1) {
                  callingId_arr.push(item.getAttribute("data-callingId"))
                }

              }
            }
          })
          if (callingId_arr.length) {
            let readMessage = {
              type: "haveReadUnread",
              from_uid: this.loginInfo.client_uid,
              to_uid: this.loginInfo.agent_uid,
              role: "client",
              callingId: callingId_arr
            };
            if (this.websocket.readyState === 1) {
              this.websocket.send(JSON.stringify({
                haveReadUnread: {
                  message: readMessage
                }
              }));
              // 把聊天记录中已读客服记录标记为已读
              callingId_arr.forEach((item1, index1) => {
                agentMsgArr.forEach((item2, index2) => {
                  if (item1 == item2.getAttribute("data-callingId")) {
                    item2.setAttribute("data-isRead", 1)
                  }
                })
              })

            }

          }

        }


      },
      contentScroll() {
        if (this.loginInfo.agent_type != 'robot') {
          // this.readServiceNews()  // 暂时不做
        }
      },
      isElementInViewport(el) {
        var rect = el.getBoundingClientRect();
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) - 50 &&
          rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
        );
      }
    },
  };
</script>

<style lang="scss">
  @import "~@/assets/css/index";

  .mob-index {
    $headerHeight: 50px; // 头部高度
    // $headerColor: #428efe; // 头部颜色
    $headerColor: #3496FB;
    $mainPadding: 20px;
    $mainHeight: 100%;
    height: $mainHeight;
    width: 100vw;
    letter-spacing:0.4px;

    input,
    textarea {
      -webkit-appearance: none;
    }

    .chat-header {
      background-color: $headerColor;
      height: $headerHeight;
      color: #fff;
      padding: 0 10px 0 $mainPadding;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      box-sizing: border-box;

      .back {
        display: inline-block;
        // background: linear-gradient(90deg, rgba(0, 94, 223, 1), rgba(96, 41, 255, 1));
        background: linear-gradient(90deg, #3A98F8, #246AF8);
        border-radius: 15px;
        padding: 3px 9px;
        color: #fff;
        font-size: 12px;
      }

      .h-service-wrap {
        line-height: 40px;
        // margin-top: 5px;
        width:68%;
        display: flex;
        align-items: center;

        .h-service-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 10px;
        }

        .h-service-nickname {
          width: calc(100% - 50px);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          .serviceName,
          .signInfo {
            line-height: 20px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .signInfo {
            font-size: 12px;
          }
        }
      }

      .h-page-handler-wrap {
        line-height: 23px;
        display: flex;
        align-items: center;
        flex: 1;
        justify-content: flex-end;

        .h-page-handler-item {
          cursor: pointer;
        }
      }
    }

    .chat-container {
      height: $mainHeight;
      display: flex;
      flex-direction: column;

      .chat-main {
        flex: 1;
        background-color: #f9f8f8;
        padding: 10px $mainPadding 50px;
        box-sizing: border-box;
        overflow-y: auto;

        .load-history {
          text-align: center;
          margin-bottom: 5px;

          span {
            font-size: 12px;
            color: #a5a5a5;
            cursor: pointer;
          }
          img{
            width: 10px;
            height: 10px;
            margin-left: 5px;
          }
        }

        .message-container {
          font-size: 13px;
          margin-bottom: 25px;

          .msg-times {
            text-align: center;
            // margin-top: 20px;

            span {
              display: inline-block;
              /*background-color: #fff;*/
              font-size: 12px;
              border-radius: 12px;
              padding: 6px 10px;
              color: #A8A8A8;
              // background: #ebebeb;
            }
          }

          .msg-item {
            width: 100%;
            margin-top: 20px;

            .chat-avatar {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              overflow: hidden;
              margin-right: 10px;
              text-align: center;
              line-height: 40px;
              float: left;
            }

            .chat-content {
              float: left;
              max-width: calc(100% - 85px);
              line-height: 18px;
              position: relative;

              a {
                color: #3396fa !important;
                cursor: pointer;
              }

              img {
                max-width: 100%;
                height: auto;
              }

              .msg-time {
                font-size: 12px;
                padding-bottom: 2px;
                color: #8FA2B3;
              }

              .msg-content {
                display: inline-block;
                border-radius: 10px;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                overflow: hidden;
                font-size: 14px;
                line-height: 22px;
                /* margin: 10px; */
                max-width: 100%;
                word-break: break-word;
                white-space: pre-wrap;
                overflow: hidden;

                .problem-item {
                  color: #488bff;
                  padding: 5px;
                  cursor: pointer;
                }

                .manual {
                  color: #488bff;
                  cursor: pointer;
                }

                .textMsg,
                &.textMsg,
                .fileMsg,
                &.fileMsg,
                .couponMsg,
                &.couponMsg,
                .placeOrderMsg,
                &.placeOrderMs,
                .expressMsg &.expressMsg {
                  padding: 6px 10px;
                }

                &.imgMsg,
                .imgMsg {
                  font-size: 0;
                  line-height: 0;

                  img {
                    max-width: 125px;
                    height: auto;
                  }
                }

                &.voiceMsg,
                .voiceMsg {
                  line-height: 28px;
                  cursor: pointer;
                  padding: 6px 10px;
                  .wifi-symbol {
                    width: 28px;
                margin-bottom: 8px;
                    height: 28px;
                    box-sizing: border-box;
                    overflow: hidden;

                    &.voice-agent {
                      float: left;
                      transform: rotate(0deg) scale(0.6);
                    }

                    &.voice-client {
                      float: right;
                      transform: rotate(180deg) scale(0.6);
                    }

                    &.bofang {
                      .second {
                        animation: bofang 1.3s infinite 0.2s;
                      }

                      .third {
                        animation: bofang 1.3s infinite 0.35s;
                      }
                    }
                  }

                  .wifi-circle {
                    width: 28px;
                margin-bottom: 8px;
                    height: 28px;
                    position: absolute;
                  }

                  .first {
                    background: url("../../assets/images/voice/1.png") no-repeat center center;
                  }

                  .second {
                    background: url("../../assets/images/voice/2.png") no-repeat center center;
                  }

                  .third {
                    background: url("../../assets/images/voice/3.png") no-repeat center center;
                  }

                  @-webkit-keyframes bofang {
                    0% {
                      opacity: 0;
                      /*初始状态 透明度为0*/
                    }

                    100% {
                      opacity: 1;
                      /*结尾状态 透明度为1*/
                    }
                  }

                  @-moz-keyframes bofang {
                    0% {
                      opacity: 0;
                      /*初始状态 透明度为0*/
                    }

                    100% {
                      opacity: 1;
                      /*结尾状态 透明度为1*/
                    }
                  }

                  @keyframes bofang {
                    0% {
                      opacity: 0;
                      /*初始状态 透明度为0*/
                    }

                    100% {
                      opacity: 1;
                      /*结尾状态 透明度为1*/
                    }
                  }
                }

                &.videoMsg,
                .videoMsg {
                  position: relative;
                  max-width: 125px;
                  line-height: 0;

                  video {
                    // max-width: 100%;
                    // display: block;
                    width: 0px;
                    height: 0px;
                    display: none;
                  }

                  video.play {
                    display: block;
                    max-width: 100%;
                    width: initial;
                    height: initial;
                  }

                  .poster {
                    max-width: 125px;
                    max-height: 300px;

                    img {
                      display: block;
                      max-width: 100%;
                      max-height: 100%;
                    }
                  }

                  .poster.play {
                    display: none;
                  }

                  .video-mask {
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    background-color: rgba(0, 0, 0, 0.5);

                    .playBtn {
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      width: 30%;
                      height: 30%;
                      transform: translate(-50%, -50%);
                      cursor: pointer;
                    }
                  }
                }

                &.fileMsg,
                .fileMsg {
                  color: #666;
                  font-size: 12px;
                  padding: 12px  12px 12px 46.5px;
                  background: url(../../assets/images/mobile/file-icon2.png) no-repeat left 12px center;
                  background-size: 26.5px 27px;
                  .view-file {
                    color: #3396fb;
                    margin-left: 5px;
                    cursor: pointer;
                  }
                }

                &.goodMsg,
                .goodMsg {
                  padding: 0;
                  /*border: none;*/
                  background-color: transparent;
                  cursor: pointer;
                  width: 145px;

                  .send-goods-box {
                    max-width: 320px;
                    margin: 0 auto;
                    background-color: transparent;
                    border-radius: 8px;
                    box-shadow: 0px 4px 21px 0px rgba(0, 0, 0, 0.07);
                    box-sizing: border-box;

                    .send-goods-info-box {
                      display: flex;
                      flex-direction: column;
                    }

                    .send-goods-image {
                      width: 145px;
                      height: 132px;
                      border-radius: 8px 8px 0 0;
                      margin-bottom: 12px;

                      img {
                        display: block;
                        width: 100%;
                        height: 100%;
                        border-radius: 8px 8px 0 0;
                      }
                    }

                    .send-goods-info {
                      font-size: 13px;
                      padding: 0 10px;

                      .send-goods-title {
                        line-height: 18px;
                        color: #333;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        margin-bottom: 20px;
                      }

                      .send-goods-price {
                        color: #E50D0D;
                        font-weight: bold;
                        margin-bottom: 8px;

                        span {
                          // padding-left: 3px;
                        }
                      }
                    }
                  }
                }

                &.couponMsg,
                .couponMsg {
                  .coupon-container {
                    display: block;
                    color: #333;
                    font-size: 12px;

                    .coupon-image {
                      width: 54px;
                      height: 54px;
                      overflow: hidden;
                      margin-right: 10px;

                      img {
                        display: inline-block;
                        width: 100%;
                        height: 100%;
                      }
                    }

                    .coupon-content {
                      max-width: calc(100% - 60px);

                      .coupon-title {
                        font-weight: bold;
                        font-size: 13px;
                        min-height: 18px;
                        overflow: hidden;
                        color: #333333;
                        margin-bottom: 2px;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                      }

                      .coupon-desc {
                        color: #666;
                        padding-top: 0px;
                        box-sizing: border-box;
                        margin-bottom: 2px;

                        span{
                          display: inline-block;
                          width: 15px;
                          margin: 4px 0px!important;
                          height: 1px;
                          line-height: 2px;
                          border-bottom: 1px solid #666;
                        }
                      }

                      .coupon-price {
                        padding-top: 0px;
                        color: #E50D0D;
                        font-weight: bold;
                        box-sizing: border-box;
                      }
                    }
                  }
                }

                &.expressMsg,
                .expressMsg {
                  padding: 6px 10px;

                  .express-container {
                    .order-no-type {
                      // display: flex;

                      .order-no {
                        flex: 1;
                        display: flex;
                        font-size: 12px;
                        color: #666666;
                        line-height: 26px;
                        overflow: hidden;

                        span {
                          display: inline-block;
                        }

                        .no {
                          max-width: calc(100% - 56px);
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        }
                      }

                      .order-type {
                        max-width: 130px;
                        white-space: nowrap;

                        span {
                          display: inline-block;
                          // border: 1px solid #666;
                          border-radius: 10px;
                          padding: 2px 0;
                          color: #333;
                          font-size: 12px;
                          font-weight: bold;
                        }

                        &.order-status1,
                        &.order-statu0,
                        &.order-status2 {
                          span {
                            color: #f4403d;
                            border-color: #f4403d;
                          }
                        }
                      }
                    }

                    .order-container {
                      margin-top: 5px;
                      display: block;
                      color: #333;
                      background: #F5F2F2;
                      padding: 5px 0;

                      .order-goods-image {
                        width: 56px;
                        height: 56px;
                        overflow: hidden;
                        margin-right: 10px;

                        img {
                          display: inline-block;
                          width: 100%;
                          height: 100%;
                        }
                      }

                      .order-goods-info {
                        max-width: calc(100% - 70px);

                        .order-goods-title {
                          line-height: 18px;
                          height: 20px;
                          margin-bottom: 4px;
                          color: #333;
                          font-weight: bold;
                          font-size: 12px;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          margin-top: 8px;
                        }
                        .order-goods-count {
                          color: #999999;
                          font-size: 11px;
                        }
                        .order-goods-price {
                          padding-top: 0px;
                          color: #E50D0D;
                          font-weight: bold;
                          box-sizing: border-box;
                        }
                      }
                    }
                  }
                }

                &.orderInfoMsg,
                .orderInfoMsg {
                  /*width: 320px;*/
                  padding: 10px;

                  .order-msg-title {
                    font-size: 13px;
                    color: #333;
                    font-weight: bold;
                  }

                  .order-msg-goods-container {
                    background: rgba(249, 249, 249, 1);
                    border-radius: 10px;
                    overflow: hidden;
                    margin-top: 12px;

                    .order-goods-img,
                    .order-goods-detail {
                      float: left;
                    }

                    .order-goods-img {
                      width: 55px;
                      height: 55px;
                      overflow: hidden;
                      margin-right: 12.5px;

                      img {
                        display: block;
                        width: 100%;
                        height: 100%;
                      }
                    }

                    .order-goods-detail {
                      height: 55px;
                      line-height: 27.5px;
                      font-size: 12px;
                      width: calc(100% - 74px);

                      .order-goods-name {
                        color: #333;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      }

                      .order-goods-count {
                        color: #999999;
                        font-size: 11px;
                      }
                    }
                  }

                  .order-msg-addr {
                    color: #666;
                    font-size: 12px;

                    .addr-item {
                      margin: 11px 0;
                    }

                    .label-name,
                    .label-content {
                      float: left;
                    }

                    .label-name {
                      width: 40px;
                    }

                    .label-content {
                      width: calc(100% - 40px);
                    }
                  }

                  .order-msg-operate {
                    text-align: center;
                    margin-top: 17px;
                    display: flex;
                    justify-content: flex-end;
                    &>div+div {
                      margin-left: 10px;
                    }
                    &>div {
                      span,
                      a {
                        display: inline-block;
                        border-radius: 11px;
                        padding: 3px 12px;
                        box-sizing: border-box;
                        font-size: 12px;
                        cursor: pointer;
                        white-space: nowrap;
                        color: #fff!important;
                        // background: linear-gradient(90deg, #005edf, #6029ff);
                        background: linear-gradient(90deg, #3A98F8, #246AF8);
                        &.toHuman {
                          background: linear-gradient(-90deg,
                            rgba(0, 191, 226, 1),
                            rgba(66, 142, 254, 1));
                          color: #fff;
                          border: none;
                        }
                      }
                    }
                    .returnGoods{
                      span,
                      a{
                        padding: 2px 12px;
                        color: #999!important;
                        background: #ffffff;
                        border:1px solid #bebebe;
                      }
                    }
                  }
                }
                &.expressMsg,
                .expressMsg,
                &.deliveryMsg,
                .deliveryMsg,
                &.arrivalMsg,
                .arrivalMsg,
                &.refundMsg,
                .refundMsg,
                &.placeOrderMsg,
                .placeOrderMsg {
                  padding: 10px 12px 16px;
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  width: 250px;

                  .orderTitle {
                    font-size: 12px;
                    font-weight: bold;
                    color: #333;
                  }

                  .orderGood-container {
                    display: flex;
                    margin: 8px 0;
                    background-color: #fafafa;
                    border-radius: 3px;
                    overflow: hidden;
                    cursor: pointer;

                    .goods-image {
                      width: 56px;
                      height: 56px;

                      img {
                        width: 100%;
                        height: 100%;
                      }
                    }

                    .goods-detail {
                      flex: 1;
                      height: 56px;
                      overflow: hidden;
                      padding: 0 4px;
                      display: flex;
                      flex-direction: column;
                      justify-content: center;
                      align-items: center;
                      box-sizing: border-box;
                      background: #F5F2F2;

                      .goods-order-title {
                        font-size: 13px;
                        color: #333;
                        width: 100%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        line-height: 25px;
                      }

                      .goods-order-detail {
                        font-size: 10px;
                        color: #666;
                        width: 100%;
                        text-align: left;
                      }
                      .goods-order-bpttom{
                        text-align: left;
                        width: 100%;
                      }
                    }
                  }

                  .deliveryTips {
                    color: #666666;
                  }

                  .operation-btn {
                    text-align: right;
                    padding-top: 8px;

                    .editBtn,
                    .confirmBtn,
                    .confirmBtned{
                      display: inline-block;
                      font-size: 13px;
                      padding: 3px 10px;
                      border-radius: 11px;
                      cursor: pointer;
                      margin-top: 5px;
                      font-size: 12px;
                    }

                    .editBtn {
                      color: #666;
                      border: 1px solid #E5E5E5;
                      border-radius: 11px;
                      margin-right: 8px;
                      background-color: transparent;
                    }

                    .confirmBtn {
                      // background: linear-gradient(90deg, rgba(0, 94, 223, 1), rgba(96, 41, 255, 1));
                      background: linear-gradient(90deg, #3A98F8, #246AF8);
                      color: #fff !important;

                      &.had {
                        background: #D3D8DB;
                        color: #666666 !important;
                      }
                    }
                    .confirmBtned{
                      background-color:#ECEDEE;
                    }

                    a {
                      background-color: #3396fb;
                      color: #fff !important;
                      font-size: 13px;
                      padding: 6px 10px;
                      border-radius: 6px;
                      cursor: pointer;

                      &.review-order-btn {
                        // background: linear-gradient(90deg, rgba(0, 94, 223, 1), rgba(96, 41, 255, 1));
                        background: linear-gradient(90deg, #3A98F8, #246AF8);
                        font-size: 12px;
                        padding: 4px 12px;
                        border-radius: 11px;
                      }
                    }
                  }
                }

                &.deliveryMsg,
                .deliveryMsg {
                  .van-icon-arrow-down {
                    cursor: pointer;
                  }

                  .deliveryInfo {
                    font-size: 12px;

                    .deliveryInfo-item {
                      display: flex;

                      .deliveryInfo-label {
                        width: 62px;
                      }

                      .deliveryInfo-detail {
                        flex: 1;
                      }
                    }
                  }
                }

                &.placeOrderMsg,
                .placeOrderMsg {
                  .addressInfo {
                    display: flex;
                    font-size: 12px;
                    color: #666;
                    margin-bottom: 10px;
                    .label {
                      width: 40px;
                    }

                    .detail {
                      flex: 1;
                    }
                  }
                }

                &.refundMsg,
                .refundMsg {
                  .order-msg-no {
                    padding-top: 6px;
                  }

                  .refundInfo {
                    font-size: 13px;
                    color: #333;
                    display: flex;
                    flex-wrap: nowrap;
                    justify-content: space-between;
                    margin-top: 10px;
                    .price{
                      color: #E50D0D;
                      font-weight: bold;
                    }
                  }
                }
              }
              .customerNew{
                border-top-left-radius: 0;
              }
              .visitorNews{
                border-top-right-radius: 0;
              }
            }
          }

          .event-msg {
            text-align: center;
            line-height: 14px;
            color: #babcbb;
          }

          .client-msg {
            .chat-avatar {
              float: right;
              margin: 0 0 0 10px;
              p{
                background-color: #3396fa;
                color: #fff;
              }
            }

            .chat-content {
              float: right;
              position: relative;
              a {
                color: #fff !important;
                text-decoration: underline;
              }
              // &:before {
              //   position: absolute;
              //   top: 4px;
              //   right: -6px;
              //   content: "";
              //   width: 0;
              //   height: 0;
              //   border-top: 6px solid transparent;
              //   border-bottom: 6px solid transparent;
              //   border-left: 6px solid #c8e6ff;
              // }

              // &:after {
              //   position: absolute;
              //   top: 4px;
              //   right: -5px;
              //   content: "";
              //   width: 0;
              //   height: 0;
              //   border-top: 6px solid transparent;
              //   border-bottom: 6px solid transparent;
              //   border-left: 6px solid #c8e6ff;
              // }

              .isreadText {
                position: absolute;
                right: 0;
                bottom: -20px;
                font-size: 12px;

                &.hasRead {
                  color: #bbb;
                }

                &.unRead {
                  color: #00aaff;
                }
              }

              .msg-time {
                text-align: right;
              }

              .msg-content {
                float: right;
                // background-color: #c8e6ff;
                // border: 1px solid #c8e6ff;
                background-color: #3496FB;
                border: 1px solid #3496FB;
                color: #fff;
              }

              &.whiteIconClass {
                .msg-content {
                  background-color: transparent;
                  border: 1px solid #fff;
                  padding: 0;
                }

                &:before {
                  border-left: 6px solid #ededed;
                }

                &:after {
                  border-left: 6px solid #fff;
                }
              }
            }
          }

          .agent-msg {
            .chat-content {
              position: relative;
              a {
                color: #333 !important;
                text-decoration: underline;
              }
              // &:before {
              //   position: absolute;
              //   top: 24px;
              //   left: -6px;
              //   content: "";
              //   width: 0;
              //   height: 0;
              //   border-top: 6px solid transparent;
              //   border-bottom: 6px solid transparent;
              //   border-right: 6px solid #ededed;
              // }

              // &:after {
              //   position: absolute;
              //   top: 24px;
              //   left: -5px;
              //   content: "";
              //   width: 0;
              //   height: 0;
              //   border-top: 6px solid transparent;
              //   border-bottom: 6px solid transparent;
              //   border-right: 6px solid #fff;
              // }

              .msg-content {
                // background-color: transparent;
                background-color: #EDF3F8;
                border: 1px solid #ededed;

                .textMsg {
                  li {
                    margin-left: 15px;
                  }

                  ol {
                    li {
                      list-style: decimal;
                    }
                  }

                  ul {
                    li {
                      list-style: disc;
                    }
                  }
                }
              }
            }
          }

          .send-goods-container {
            .send-goods-box {
              max-width: 320px;
              margin: 0 auto;
              background-color: transparent;
              border-radius: 8px;
              box-shadow: 0px 4px 21px 0px rgba(0, 0, 0, 0.07);
              padding: 12px;
              box-sizing: border-box;
              position: relative;

              .send-goods-info-box {
                display: block;
              }

              .send-goods-image {
                width: 67px;
                height: 67px;
                border-radius: 5px;
                margin-right: 10px;
                overflow: hidden;

                img {
                  display: inline-block;
                  width: 100%;
                  height: 100%;
                  border-radius: 5px;
                }
              }

              .send-goods-info {
                max-width: calc(100% - 80px);
                font-size: 13px;

                .send-goods-title {
                  height: 36px;
                  line-height: 18px;
                  margin-bottom: 10px;
                  color: #333;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }

                .send-goods-price {
                  color: #E50D0D;
                  font-weight: bold;

                  span {
                    // padding-left: 3px;
                  }
                }
              }

              .send-goods-btn-wrap {
                text-align: center;
                position: absolute;
                right: 12px;
                bottom: 8px;

                .send-goods-btn {
                  display: block;
                  border-radius: 11px;
                  color: #fff;
                  padding: 5px 10px;
                  box-sizing: border-box;
                  cursor: pointer;
                  font-size: 12px;
                  // background: linear-gradient(90deg, rgba(0, 94, 223, 1), rgba(96, 41, 255, 1));
                  background: linear-gradient(90deg, #3A98F8, #246AF8);
                }
              }
            }
          }
        }
      }

      .chat-bottom {
        min-height: 50px;
        background-color: #f9f8f8;
        position: relative;
        padding: 10px 15px;
        box-sizing: border-box;

        .ai-tips {
          text-align: center;
          font-size: 12px;
          color: #999;
          padding-top: 8px;
          line-height: 1.2;
        }

        .chat-operate {
          height: 50px;
          padding: 0 15px;
          box-sizing: border-box;
          background-color: #f9f8f8;
          border-radius: 24px;
          box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08);
          border: none;
          display: flex;
          align-items: center;

          .operate-icon {
            &.left {
              margin-right: 15px;
            }

            padding-left: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            .operation-voice,.operation-emoji,.operation-plus{
              display: inline-block;
            }
            .svg-icon {
              width: 28px;
              height: 28px;
            }
            .operation-voice{
              width: 24px;
              height: 24px;
              background: url(../../assets/images/mobile/voice-icon.png) no-repeat center;
              background-size: 100% 100%;
            }
            .operation-emoji{
              width: 24px;
              height: 24px;
              background: url(../../assets/images/mobile/emoji-icon.png) no-repeat center;
              background-size: 100% 100%;
            }
            .operation-plus{
              width: 24px;
              height: 24px;
              background: url(../../assets/images/mobile/adds.png) no-repeat center;
              background-size: 100% 100%;
            }
            .sendBtn {
              display: inline-block;
              background-color: #3396fa;
              color: #fff;
              padding: 5px 12px;
              box-sizing: border-box;
              border-radius: 15px;
              margin-left: 0;
              font-size: 13px;
            }
          }

          .input-wrap {
            flex: 1;
            border: none;
            border-radius: 0;
            min-height: 36px;
            margin-left: 10px;
            margin-right: 10px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            background-color: transparent;
            position: relative;

            input {
              width: 100%;
              border: none;
              outline: none;
              resize: none;
              background-color: transparent;
              padding: 0 8px;
              font-size: 14px;
              height: 36px;
              line-height: 36px;

              &::placeholder {
                color: #999;
              }
            }

            .voiceRecordBtn {
              display: block;
              width: 100%;
              height: 36px;
              line-height: 36px;
              text-align: center;
              font-size: 14px;
              color: #333;
              background-color: #f7f7f7;
              border-radius: 18px;
              -webkit-touch-callout: none;
              -webkit-user-select: none;
              -khtml-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              user-select: none;
            }
          }
        }

        .chat-input-contianer {
          display: flex;
          flex: 1;
          align-items: center;
          width: 100%;
        }

        .chat-end-container {
          background: transparent;

          &.black-container {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 13px;
            color: #999;
          }

          .chat-end-operate {
            height: 100%;
            display: flex;
            align-items: center;
            flex: 1;

            .svg-icon {
              margin: 0;
            }

            li {
              float: left;
              height: 100%;
              line-height: 1;
              width: 33.33%;
              text-align: center;
              position: relative;
              color: #707070;
              font-size: 13px;
              padding-top: 8px;
              box-sizing: border-box;

              &>div {
                cursor: pointer;
              }

              .chat-end-operate-title {
                display: inline-block;
                margin-top: 8px;
              }
            }

            &.no-evaluate {
              li {
                width: 50%;
              }
            }
          }
        }

        .more-operation {
          .emoji_pannel {
            position: relative;
            top: 0;
            z-index: 0;
            width: 100%;
          }

          .css_moreFn {
            display: flex;
            padding: 15px 0;
            flex-wrap: nowrap;
            background-color: transparent;
            justify-content: space-around;

            .svg-icon {
              margin: 0;
            }

            .fnItem {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              width: 28vw;
              height: 28vw;
              max-width: 100px;
              max-height: 100px;
              background-color: #fff;
              border-radius: 12px;
              box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.06);
              margin: 0;

              .itemPosition {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;
              }

              .svg-icon {
                width: 28px;
                margin-bottom: 8px;
                height: 28px;
                color: #333;
              }

              .itemName {
                font-size: 13px;
                padding-top: 0;
                color: #333;
              }
            }
          }
        }
      }

      .evaluate-pannel {
        position: absolute;
        top: 49px;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.3);

        .evaluate-container {
          // background-color: transparent;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 91%;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          padding: 15px;
          box-sizing: border-box;
          overflow-y: auto;

          .evaluate-title {
            text-align: center;
            font-size: 16px;
            color: #333;
            position: relative;

            .evaluate-pannel-close {
              position: absolute;
              top: 0;
              right: 0;
              cursor: pointer;
            }
          }

          .evaluate-level {
            text-align: center;
            padding: 10px 0;
            width: 240px;
            margin: 0 auto;
            box-sizing: border-box;
            font-size: 12px;
            color: #666;

            &>div {
              float: left;
              cursor: pointer;
              width: 45px;
              padding: 10px 0 6px;
              border: 1px solid #fff;

              &.chosen {
                background-color: #fafafa;
                border: 1px solid #f0f0f0;
                border-radius: 4px;
              }
            }

            .level-title {
              padding-top: 10px;
              box-sizing: border-box;
            }
          }

          .evaluate-level-name {
            text-align: center;
            font-size: 12px;
            padding-bottom: 5px;
            box-sizing: border-box;

            span {
              color: #428efe;
              /*&.satisfied {
                color: $colorSatisfied;
              }

              &.very {
                color: $colorVery;
              }

              &.normal {
                color: $colorNormal;
              }

              &.less {
                color: $colorLess;
              }

              &.worse {
                color: $colorWorse;
              }*/
            }
          }

          .evaluate-quick-content {
            font-size: 13px;
            padding-bottom: 15px;
            text-align: center;

            span {
              cursor: pointer;
              display: inline-block;
              background-color: #eaf2ff;
              /*background-color: #efefef;*/
              /*color: #505050;*/
              color: #428efe;
              padding: 10px 19px;
              border-radius: 16px;
              margin-top: 10px;
              margin-right: 10px;
            }

            &.wrapVery {
              .tagActive {
                background-color: #428efe;
                color: #fff;
              }
            }

            &.wrapSatisfied {
              .tagActive {
                background-color: #428efe;
                color: #fff;
              }
            }

            &.wrapNormal {
              .tagActive {
                background-color: #428efe;
                color: #fff;
              }
            }

            &.wrapLess {
              .tagActive {
                background-color: #428efe;
                color: #fff;
              }
            }

            &.wrapWorse {
              .tagActive {
                background-color: #428efe;
                color: #fff;
              }
            }
          }

          .evaluate-content-wrap {
            /*height: 40%;*/
          }

          .evaluate-content {
            resize: none;
            width: 100%;
            border: 1px solid #e5e5e5;
            font-size: 12px;
            border-radius: 4px;
            padding: 8px;
            outline: none;
            line-height: 16px;
            box-sizing: border-box;
            background: none;
          }

          .evaluate-submit {
            text-align: center;
            padding-top: 15px;

            span {
              width: 80%;
              display: inline-block;
              font-size: 14px;
              padding: 10px 15px;
              text-align: center;
              color: #fff;
              cursor: pointer;
              background-color: #488bff;
              border-radius: 18px;

              &.btnDisabled {
                background-color: #dae4ed;
                cursor: not-allowed;
              }
            }
          }
        }
      }
    }

    .leave-msg-container {
      background-color: transparent;
      height: $mainHeight;
      overflow-y: auto;

      .leave-msg-main {
        padding: 15px;
        box-sizing: border-box;

        .leave-msg-tips {
          color: #8a9099;
          font-size: 14px;
          line-height: 22px;
          word-break: break-all;
        }

        .form-item {

          .item-title {
            font-size: 14px;
            color: #8fa1b2;

            span {
              color: red;
            }
          }

          .item-content {
            width: 100%;
            border: 1px solid #eee;
            border-radius: 4px;
            line-height: 40px;
            outline: none;
            padding: 0 8px;
            box-sizing: border-box;
            margin-top: 5px;

            &.problem-detail {
              resize: none;
              line-height: 20px;
              height: 100px;
              overflow: auto;
              padding: 8px;
              box-sizing: border-box;
            }
          }
        }

        .leave-msg-submit {
          text-align: center;
          padding-top: 15px;

          span {
            display: inline-block;
            width: 180px;
            height: 45px;
            line-height: 45px;
            text-align: center;
            color: #fff;
            cursor: pointer;
            background-color: #488bff;
            border-radius: 24px;
            &.btnDisabled {
              background-color: #dae4ed;
              cursor: not-allowed;
            }
          }
        }
      }
    }

    .lineup-container {
      height: 100%;

      .lineup-main {
        height: calc(100% - 50px);
        padding: 15px 10px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;

        .lineup-tips {
          font-size: 13px;
          line-height: 22px;
          padding-bottom: 20px;
          box-sizing: border-box;
          height: 65px;
          max-height: 100px;
          overflow-y: auto;
        }

        .lineup-count {
          flex: 1;
          display: flex;
          flex-direction: column;
          text-align: center;
          border-top: 1px solid #eee;
          border-bottom: 1px solid #eee;
          padding: 20px 0;
          box-sizing: border-box;
          justify-content: center;
          color: #3396fa;

          .count-tips {}

          .count-num {
            font-size: 40px;
            font-weight: bold;
            margin-top: 20px;

            span {
              font-size: 13px;
              font-weight: normal;
              padding-left: 6px;
            }
          }
        }

        .lineup-operation {
          height: 125px;
          padding-top: 30px;
          box-sizing: border-box;
          text-align: center;
          font-size: 13px;

          .to-leave-msg-btn {
            background-color: #3396fa;
            color: #fff;
            padding: 10px 0;
            width: 150px;
            margin: 10px auto 0;
            box-sizing: border-box;
          }
        }
      }
    }

    .quick-guide-box {
      position: absolute;
      top: -40px;
      // background-color: #ededed;
      background-color: #ffffff;
      left: 15px;
      right: 15px;
      padding: 0;
      padding-bottom: 6px;
      display: flex;
      p{
        color: #666;
        width: 40px;
        line-height: 28px;
      }
      .quick-guide-list {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        width:calc(100% - 40px);
        overflow-x: auto;

        li {
          // background-color: #f7f7f7;
          background-color: transparent;
          color: #999;
          padding: 6px 12px;
          border-radius: 15px;
          margin-right: 10px;
          white-space: nowrap;
          border: 1px solid #E5E5E5;
          &.hide {
            display: none;
          }
        }
      }

    }

    .quick-guide-list::-webkit-scrollbar {
      display: none;
    }
  }
</style>
